(function () {
  'use strict';

  var FILTERS = [
    ['all', 'All exact-fit'],
    ['protective', 'Maximum protection'],
    ['stand', 'Integrated stand'],
    ['work', 'Work & field'],
    ['travel', 'Travel-ready'],
    ['metal', 'Metal'],
    ['leather', 'Leather']
  ];

  var PRIORITIES = [
    ['protection', 'Maximum protection'],
    ['materials', 'Premium materials'],
    ['stand', 'Stand versatility'],
    ['travel', 'Travel'],
    ['work', 'Workplace use'],
    ['outdoor', 'Outdoor use'],
    ['minimal', 'Minimal design'],
    ['value', 'Best value']
  ];

  var CATEGORY_ORDER = ['Phone', 'Tablet', 'Watch', 'Laptop'];
  var BRAND_ORDER = ['Apple', 'Samsung', 'Google', 'Microsoft', 'Motorola', 'OnePlus', 'Garmin', 'Fitbit', 'Amazfit', 'Suunto', 'Fossil'];

  var QUICK_DEVICES = [
    'iPad Air 11-inch M4',
    'Samsung Galaxy Z Fold 8',
    'Motorola Razr Fold',
    'Fitbit Air'
  ];

  var DISPLAY_CURRENCY = 'USD';
  var DISPLAY_LOCALE = document.documentElement.lang || 'en-US';

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&amp;/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function stripHtml(value) {
    var template = document.createElement('template');
    template.innerHTML = String(value || '');
    return template.content.textContent || '';
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function tagsOf(product) {
    return Array.isArray(product.tags)
      ? product.tags
      : String(product.tags || '').split(',').map(function (tag) { return tag.trim(); });
  }

  var PRODUCT_TEXT_CACHE = typeof WeakMap === 'function' ? new WeakMap() : null;

  function productText(product, variant) {
    if (!PRODUCT_TEXT_CACHE) {
      return normalize([
        product.title,
        product.product_type,
        tagsOf(product).join(' '),
        stripHtml(product.body_html || ''),
        variant ? variant.title : ''
      ].join(' '));
    }

    var cached = PRODUCT_TEXT_CACHE.get(product);
    if (!cached) {
      cached = {
        base: normalize([
          product.title,
          product.product_type,
          tagsOf(product).join(' '),
          stripHtml(product.body_html || '')
        ].join(' ')),
        variants: new Map()
      };
      PRODUCT_TEXT_CACHE.set(product, cached);
    }
    if (!variant) return cached.base;

    var variantKey = String(variant.id || variant.title || 'default');
    if (!cached.variants.has(variantKey)) cached.variants.set(variantKey, normalize(cached.base + ' ' + (variant.title || '')));
    return cached.variants.get(variantKey);
  }

  function containsToken(text, term) {
    var needle = normalize(term);
    return !needle || (' ' + text + ' ').indexOf(' ' + needle + ' ') !== -1;
  }

  function titleCaseDevice(value) {
    var protectedTerms = {
      ipad: 'iPad', iphone: 'iPhone', iwatch: 'Apple Watch', macbook: 'MacBook',
      samsung: 'Samsung', galaxy: 'Galaxy', google: 'Google', pixel: 'Pixel',
      fitbit: 'Fitbit', garmin: 'Garmin', oneplus: 'OnePlus', motorola: 'Motorola',
      razr: 'Razr', surface: 'Surface', microsoft: 'Microsoft', pro: 'Pro', max: 'Max',
      ultra: 'Ultra', plus: 'Plus', mini: 'Mini', air: 'Air', se: 'SE', fe: 'FE',
      classic: 'Classic', lite: 'Lite', note: 'Note', fold: 'Fold', flip: 'Flip'
    };
    return String(value || '').replace(/\b[a-z]+\b/gi, function (word) {
      return protectedTerms[word.toLowerCase()] || word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).replace(/\b(\d{2}(?:\.\d+)?)\s*mm\b/gi, '$1mm')
      .replace(/\b(\d{1,2}(?:\.\d+)?)\s*[- ]?\s*(?:in|inch)\b/gi, '$1-inch')
      .replace(/\s+/g, ' ').trim();
  }

  function classifyDeviceLabel(label) {
    var text = normalize(label);
    if (/\biphone\b/.test(text)) return { category: 'Phone', brand: 'Apple' };
    if (/\bipad\b/.test(text)) return { category: 'Tablet', brand: 'Apple' };
    if (/\b(?:apple watch|iwatch)\b/.test(text)) return { category: 'Watch', brand: 'Apple' };
    if (/\bmacbook\b/.test(text)) return { category: 'Laptop', brand: 'Apple' };
    if (/\bgalaxy tab\b/.test(text)) return { category: 'Tablet', brand: 'Samsung' };
    if (/\bgalaxy watch\b/.test(text)) return { category: 'Watch', brand: 'Samsung' };
    if (/\bgalaxy (?:s|a|note|z fold|z flip)\b/.test(text)) return { category: 'Phone', brand: 'Samsung' };
    if (/\bsurface laptop\b/.test(text)) return { category: 'Laptop', brand: 'Microsoft' };
    if (/\bsurface\b/.test(text)) return { category: 'Tablet', brand: 'Microsoft' };
    if (/\bpixel watch\b/.test(text)) return { category: 'Watch', brand: 'Google' };
    if (/\bpixel\b/.test(text)) return { category: 'Phone', brand: 'Google' };
    if (/\brazr\b|\bmoto(?:rola)?\b/.test(text)) return { category: 'Phone', brand: 'Motorola' };
    if (/\boneplus\b/.test(text)) return { category: 'Phone', brand: 'OnePlus' };
    if (/\bgarmin\b/.test(text)) return { category: 'Watch', brand: 'Garmin' };
    if (/\bfitbit\b/.test(text)) return { category: 'Watch', brand: 'Fitbit' };
    if (/\bamazfit\b/.test(text)) return { category: 'Watch', brand: 'Amazfit' };
    if (/\bsuunto\b/.test(text)) return { category: 'Watch', brand: 'Suunto' };
    if (/\bfossil\b/.test(text)) return { category: 'Watch', brand: 'Fossil' };
    return null;
  }

  function cleanDeviceValue(value) {
    return String(value || '')
      .replace(/\s*\|\s*(?:united states|italy|france|china|spain|us)\b.*$/i, '')
      .replace(/^\s*(?:for|fits|compatible with)\s+/i, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function canonicalDeviceCandidates(value, product, optionName) {
    var raw = cleanDeviceValue(value);
    var context = [product.title, product.product_type, tagsOf(product).join(' ')].join(' ');
    var combined = raw + ' ' + context;
    var candidates = [];

    function add(label) {
      var cleaned = titleCaseDevice(String(label || '')
        .replace(/^for\s+/i, '')
        .replace(/\b(?:case|cover|screen protector|tempered glass|protective shell|keyboard|charger|charging dock|tripod|holder)\b.*$/i, '')
        .replace(/\s+/g, ' ').trim());
      if (cleaned && classifyDeviceLabel(cleaned) && candidates.indexOf(cleaned) === -1) candidates.push(cleaned);
    }

    var iphoneRange = raw.match(/iphone\s*(\d{1,2})\s*(?:or|\/|&)\s*(\d{1,2})/i);
    if (iphoneRange) { add('iPhone ' + iphoneRange[1]); add('iPhone ' + iphoneRange[2]); }
    var iphonePattern = /iphone\s*(se(?:\s*(?:2|3)(?:nd|rd)?(?:\s*gen(?:eration)?)?)?|x(?:r|s)?|\d{1,2})\s*(pro\s*max|promax|pro|max|plus|mini|air|e)?/ig;
    var iphoneMatch;
    while ((iphoneMatch = iphonePattern.exec(raw))) {
      add('iPhone ' + iphoneMatch[1] + (iphoneMatch[2] ? ' ' + iphoneMatch[2].replace(/promax/i, 'Pro Max') : ''));
    }
    if (candidates.length && /iphone/i.test(raw)) return candidates;

    var ipadCodes = combined.match(/\ba\d{4}\b/ig) || [];
    if (/ipad/i.test(combined) && ipadCodes.length) ipadCodes.forEach(function (code) { add('iPad ' + code.toUpperCase()); });
    if (/ipad/i.test(raw) || (/ipad/i.test(context) && /ipad|model|size/i.test(optionName || ''))) {
      var ipadSource = /ipad/i.test(raw) ? raw.slice(raw.search(/ipad/i)) : raw;
      var ipadValue = ipadSource.replace(/^ipad\s*/i, '').replace(/^apple\s*/i, '');
      if (ipadValue && !/^(default title|one size)$/i.test(ipadValue)) add('iPad ' + ipadValue);
      return candidates;
    }

    if (/apple watch|iwatch/i.test(combined) || (/watch/i.test(context) && /band width|dial|case size|watch series/i.test(optionName || ''))) {
      var appleSizeMatch = raw.match(/\b(38|40|41|42|44|45|46|49)\s*mm\b/i);
      var appleSize = appleSizeMatch && appleSizeMatch[1] + 'mm';
      var ultraGeneration = (combined.match(/\bultra\s*([1-3])\b/i) || [])[1];
      if (/\bultra\b/i.test(combined) && (appleSize === '49mm' || /49\s*mm/i.test(context))) {
        add('Apple Watch Ultra' + (ultraGeneration ? ' ' + ultraGeneration : '') + ' 49mm');
      }
      var seriesSource = raw.match(/series\s*((?:se\s*)?(?:\d{1,2}\s*)+)/i) || context.match(/series\s*((?:se\s*)?(?:\d{1,2}\s*)+)/i);
      if (seriesSource && appleSize) {
        if (/\bse\b/i.test(seriesSource[1])) add('Apple Watch SE ' + appleSize);
        (seriesSource[1].match(/\d{1,2}/g) || []).forEach(function (series) { add('Apple Watch Series ' + series + ' ' + appleSize); });
      }
      if (!candidates.length && appleSize) add('Apple Watch ' + appleSize);
      if (candidates.length) return candidates;
    }

    if (/galaxy\s*(?:watch)?|samsung watch/i.test(combined) && /watch|dial|band|size/i.test((optionName || '') + ' ' + context)) {
      var galaxyWatchSizes = [];
      var galaxySizePattern = /\b(40|41|42|43|44|45|46|47)\s*mm\b/ig;
      var galaxySizeMatch;
      while ((galaxySizeMatch = galaxySizePattern.exec(raw))) if (galaxyWatchSizes.indexOf(galaxySizeMatch[1]) === -1) galaxyWatchSizes.push(galaxySizeMatch[1]);
      var galaxyWatchSize = galaxyWatchSizes[0] || (context.match(/\b(40|41|42|43|44|45|46|47)\s*mm\b/i) || [])[1];
      var rawGalaxyGeneration = raw.match(/(?:galaxy\s*)?watch\s*([1-9])\b/i) || raw.match(/^\s*([1-9])\s*(?:classic|pro|ultra|\d{2}\s*mm|$)/i);
      var contextGalaxyGeneration = context.match(/galaxy watch\s*([1-9])\b/i);
      var galaxyWatchGeneration = (rawGalaxyGeneration || contextGalaxyGeneration || [])[1];
      var rawGalaxyStyle = raw.match(/\b(classic|pro|ultra)\b/i);
      var contextGalaxyStyle = context.match(/galaxy watch[^,–-]*\b(classic|pro|ultra)\b/i);
      var galaxyWatchStyle = (rawGalaxyStyle || (!rawGalaxyGeneration && contextGalaxyStyle) || [])[1];
      if (galaxyWatchStyle && galaxyWatchStyle.toLowerCase() === 'ultra') {
        if (galaxyWatchSize === '47') add('Samsung Galaxy Watch Ultra 47mm');
      }
      else if (galaxyWatchGeneration) (galaxyWatchSizes.length ? galaxyWatchSizes : [galaxyWatchSize || '']).forEach(function (size) { add('Samsung Galaxy Watch ' + galaxyWatchGeneration + (galaxyWatchStyle ? ' ' + galaxyWatchStyle : '') + (size ? ' ' + size + 'mm' : '')); });
      else if (galaxyWatchSize) add('Samsung Galaxy Watch ' + galaxyWatchSize + 'mm');
      if (candidates.length) return candidates;
    }

    if (/galaxy tab/i.test(combined) && /model|size|tablet/i.test((optionName || '') + ' ' + context)) {
      var tabValue = raw.replace(/^(?:samsung\s*)?(?:galaxy\s*)?tab\s*/i, '');
      if (tabValue) add('Samsung Galaxy Tab ' + tabValue);
      return candidates;
    }

    if (/surface/i.test(combined)) {
      var surfaceMatch = raw.match(/surface\s*(pro|go|laptop|book)\s*(.*)/i) || combined.match(/surface\s*(pro|go|laptop|book)\s*(.*)/i);
      if (surfaceMatch) {
        var surfaceModels = (surfaceMatch[2].match(/\d+(?:\.\d+)?/g) || []).filter(function (model) {
          return model.indexOf('.') === -1 && Number(model) >= 1 && Number(model) <= 12;
        });
        if (/\bx\b/i.test(surfaceMatch[2])) surfaceModels.push('X');
        uniqueCatalogValues(surfaceModels).forEach(function (model) { add('Microsoft Surface ' + surfaceMatch[1] + ' ' + model); });
      }
      if (candidates.length) return candidates;
    }

    var foldFlip = raw.match(/(?:samsung\s*)?(?:galaxy\s*)?(?:z\s*)?(fold|flip)\s*(\d+)/i);
    if (foldFlip) add('Samsung Galaxy Z ' + foldFlip[1] + ' ' + foldFlip[2]);
    var galaxyS = raw.match(/(?:samsung\s*)?(?:galaxy\s*)?s\s*(\d+)\s*(ultra|plus|edge|fe|\+)?/i);
    if (galaxyS) add('Samsung Galaxy S' + galaxyS[1] + (galaxyS[2] ? ' ' + (galaxyS[2] === '+' ? 'Plus' : galaxyS[2]) : ''));
    var galaxyNote = raw.match(/(?:samsung\s*)?(?:galaxy\s*)?note\s*(\d+)\s*(ultra|plus|\+)?/i);
    if (galaxyNote) add('Samsung Galaxy Note ' + galaxyNote[1] + (galaxyNote[2] ? ' ' + (galaxyNote[2] === '+' ? 'Plus' : galaxyNote[2]) : ''));
    var galaxyA = raw.match(/(?:samsung\s*)?(?:galaxy\s*)?a\s*(\d+)\s*(?:5g|4g)?/i);
    if (galaxyA) add('Samsung Galaxy A' + galaxyA[1]);
    if (candidates.length) return candidates;

    var pixelWatchPattern = /pixel\s*watch\s*(\d+)?\s*(\d{2})?\s*(?:mm)?/ig;
    var pixelWatch;
    while ((pixelWatch = pixelWatchPattern.exec(raw))) add('Google Pixel Watch' + (pixelWatch[1] ? ' ' + pixelWatch[1] : '') + (pixelWatch[2] ? ' ' + pixelWatch[2] + 'mm' : ''));
    var pixelPhone = raw.match(/pixel\s*(\d+[a-z]?)\s*(pro\s*xl|pro|xl|fold|a)?/i);
    if (pixelPhone && !/watch/i.test(raw)) add('Google Pixel ' + pixelPhone[1] + (pixelPhone[2] ? ' ' + pixelPhone[2] : ''));
    if (candidates.length) return candidates;

    if (/(?:motorola\s*)?razr\s*fold\b/i.test(raw)) add('Motorola Razr Fold');
    var razr = raw.match(/(?:motorola\s*)?razr\s*(plus\s*)?(\d{2,4})\s*(ultra|plus)?/i);
    if (razr) add('Motorola Razr ' + (razr[1] ? 'Plus ' : '') + razr[2] + (razr[3] ? ' ' + razr[3] : ''));
    var onePlus = raw.match(/oneplus\s*(\d+)\s*(pro|r)?/i);
    if (onePlus) add('OnePlus ' + onePlus[1] + (onePlus[2] ? ' ' + onePlus[2] : ''));
    if (candidates.length) return candidates;

    var fitbit = raw.match(/fitbit\s*(air|versa\s*\d+|sense\s*\d*|charge\s*\d+|luxe|ionic|inspire\s*\d*)/i) || context.match(/fitbit\s*(air|versa\s*\d+|sense\s*\d*|charge\s*\d+|luxe|ionic|inspire\s*\d*)/i);
    if (fitbit) add('Fitbit ' + fitbit[1]);
    var fitbitPair = raw.match(/fitbit\s*charge\s*(\d+)\s*(?:&|and|\/)\s*(?:charge\s*)?(\d+)/i);
    if (fitbitPair) { add('Fitbit Charge ' + fitbitPair[1]); add('Fitbit Charge ' + fitbitPair[2]); }
    if (candidates.length) return candidates;

    if (/garmin/i.test(context)) {
      var garminWidth = raw.match(/\b(18|20|22|26)\s*mm\b/i);
      if (garminWidth) add('Garmin ' + garminWidth[1] + 'mm');
      var garminModel = raw.match(/\b(fenix|epix|instinct|enduro|marq|tactix|descent|forerunner|quatix)\s*([a-z0-9 ]+)?/i);
      if (garminModel) add('Garmin ' + garminModel[1] + (garminModel[2] ? ' ' + garminModel[2] : ''));
      if (candidates.length) return candidates;
    }

    ['Amazfit', 'Suunto', 'Fossil'].forEach(function (brand) {
      var brandPattern = new RegExp(brand + '\\s*([a-z0-9 +.-]+)', 'i');
      var brandMatch = raw.match(brandPattern) || context.match(brandPattern);
      if (brandMatch) add(brand + ' ' + brandMatch[1].split(/\b(?:band|case|strap|screen|protector)\b/i)[0]);
    });

    if (/macbook/i.test(combined)) {
      var macCodes = combined.match(/\ba\d{4}\b/ig) || [];
      if (macCodes.length) macCodes.forEach(function (code) { add('Apple MacBook ' + code.toUpperCase()); });
      else if (raw) add('Apple MacBook ' + raw.replace(/^mac(?:book)?\s*/i, ''));
    }
    return candidates;
  }

  function optionMayContainDevice(optionName, value, product) {
    var name = normalize(optionName);
    var text = normalize(value + ' ' + product.title + ' ' + product.product_type);
    if (/color|ships from|bundle|quantity|style|lens|frame|plug|set|ring size/.test(name)) return false;
    if (/model|iphone|ipad|tablet|watch|dial|band width|case size|surface|macbook|phone/.test(name)) return true;
    if (/^(size|material)$/.test(name) && /iphone|ipad|galaxy|samsung|pixel|surface|fitbit|garmin|razr|oneplus|watch|macbook/.test(text)) return true;
    return /iphone|ipad|apple watch|iwatch|galaxy (?:watch|tab|s\d|a\d|z fold|z flip|note)|surface|pixel|fitbit|garmin|razr|oneplus|macbook/.test(normalize(value));
  }

  function sortedDeviceOptions(index) {
    return Array.from(index.values()).sort(function (a, b) {
      var categoryDifference = CATEGORY_ORDER.indexOf(a.category) - CATEGORY_ORDER.indexOf(b.category);
      if (categoryDifference) return categoryDifference;
      var aBrand = BRAND_ORDER.indexOf(a.brand); var bBrand = BRAND_ORDER.indexOf(b.brand);
      var brandDifference = (aBrand === -1 ? 999 : aBrand) - (bBrand === -1 ? 999 : bBrand);
      if (brandDifference) return brandDifference;
      return b.label.localeCompare(a.label, undefined, { numeric: true, sensitivity: 'base' });
    });
  }

  function isValidCanonicalCandidate(label, profile) {
    var resolved = profile || resolveDevice(label);
    if (!resolved || !resolved.groups || !resolved.groups.length || resolved.ambiguity) return false;
    if (resolved.kind !== 'iphone') return true;

    var model = String(resolved.model || '').toLowerCase();
    var edition = String(resolved.edition || 'base').toLowerCase();
    var number = Number(model);
    if (model === '9' || model === '10') return false;
    if (edition === 'mini' && ['12', '13'].indexOf(model) === -1) return false;
    if (edition === 'plus' && ['6', '7', '8', '14', '15', '16'].indexOf(model) === -1) return false;
    if (edition === 'air' && model !== '17') return false;
    if (edition === 'e' && model !== '16') return false;
    if (edition === 'max' && model !== 'xs') return false;
    if ((edition === 'pro' || edition === 'pro max') && Number.isFinite(number) && number < 11) return false;
    return true;
  }

  async function buildCatalogDeviceOptions(catalog, onProgress) {
    var index = new Map();

    function addCandidate(label, product, verifiedVariants) {
      var profile = resolveDevice(label);
      if (!isValidCanonicalCandidate(label, profile)) return;
      var canonicalLabel = profile.label || label;
      var classification = classifyDeviceLabel(canonicalLabel) || classifyDeviceLabel(label);
      if (!classification) return;
      var exactVariants = Array.isArray(verifiedVariants) && verifiedVariants.length
        ? verifiedVariants.filter(function (variant) { return matchesVariant(product, variant, profile); })
        : matchingVariants(product, profile);
      if (!exactVariants.length) return;
      primeMatchingVariants(product, profile, exactVariants);
      var key = classification.category + '|' + classification.brand + '|' + (profile.key || normalize(canonicalLabel));
      if (!index.has(key)) index.set(key, { category: classification.category, brand: classification.brand, label: canonicalLabel, sourceHandles: [] });
      var entry = index.get(key);
      if (entry.sourceHandles.indexOf(product.handle) === -1) entry.sourceHandles.push(product.handle);
    }

    for (var productIndex = 0; productIndex < catalog.length; productIndex += 1) {
      var product = catalog[productIndex];
      var availableVariants = (product.variants || []).filter(function (variant) { return variant.available; });
      if (!availableVariants.length) continue;
      if (window.AvonticWatchQualifiedFit) window.AvonticWatchQualifiedFit.modelLabelsForProduct(product).forEach(function(label){ addCandidate(label, product); });
      productText(product);
      availableVariants.forEach(function (variant) { productText(product, variant); });
      var options = Array.isArray(product.options) ? product.options : [];
      options.forEach(function (option, optionIndex) {
        var optionName = typeof option === 'string' ? option : option.name;
        var optionValues = typeof option === 'string' || !Array.isArray(option.values)
          ? uniqueCatalogValues((product.variants || []).map(function (variant) { return variant['option' + (optionIndex + 1)]; }))
          : option.values;
        optionValues.forEach(function (value) {
          if (!optionMayContainDevice(optionName, value, product)) return;
          var optionKey = 'option' + (optionIndex + 1);
          var exactAvailableVariants = availableVariants.filter(function (variant) {
            return cleanDeviceValue(variant[optionKey]) === cleanDeviceValue(value);
          });
          canonicalDeviceCandidates(value, product, optionName).forEach(function (label) { addCandidate(label, product, exactAvailableVariants); });
        });
      });
      canonicalDeviceCandidates(product.title, product, 'Product title').forEach(function (label) { addCandidate(label, product); });
      tagsOf(product).forEach(function (tag) {
        canonicalDeviceCandidates(tag, product, 'Product tag').forEach(function (label) { addCandidate(label, product); });
      });

      if ((productIndex + 1) % 40 === 0) {
        if (typeof onProgress === 'function') onProgress(productIndex + 1, catalog.length, index);
        await new Promise(function (resolve) { window.setTimeout(resolve, 0); });
      }
    }

    if (typeof onProgress === 'function') onProgress(catalog.length, catalog.length, index);
    return sortedDeviceOptions(index);
  }

  function uniqueCatalogValues(values) {
    return values.filter(function (value, index) { return value && values.indexOf(value) === index; });
  }

  function resolveDevice(raw) {
    if (/\b(?:apple\s*watch|iwatch)\s*(?:series\s*12|ultra\s*4)\b|^(?:series\s*12|ultra\s*4)\b/i.test(String(raw || ''))) return window.AvonticWatchQualifiedFit ? window.AvonticWatchQualifiedFit.resolveDevice(raw) : { key: String(raw).toLowerCase(), label: String(raw), family: 'Apple Watch', kind: 'apple-watch', groups: [['apple watch']], variantGroups: [], ambiguity: "New-model accessory fit confirmation is pending. Explore the Apple Watch launch guide or select a currently supported model.", signals: [] };
    var canonicalEngine = window.AvonticCompatibility;
    if (canonicalEngine && typeof canonicalEngine.resolveDevice === 'function') {
      var canonicalProfile = canonicalEngine.resolveDevice(String(raw || ''));
      if (canonicalProfile && canonicalProfile.kind !== 'unknown') return canonicalProfile;
    }
    var query = normalize(raw);
    var codeMatch = query.match(/\b(a\d{4}|sm\s?[a-z]?\d{3,4}[a-z]?|model\s?\d{4})\b/);
    if (codeMatch) {
      var compact = codeMatch[1].replace(/\s/g, '');
      return {
        key: compact,
        label: String(raw).trim().toUpperCase(),
        family: compact.indexOf('a') === 0 ? 'Apple device' : 'Manufacturer model',
        groups: [[compact]],
        variantGroups: [[compact]],
        code: compact
      };
    }

    var iphone = query.match(/iphone\s*(\d+)\s*(pro max|pro|plus|air|max)?/);
    if (iphone) {
      var iphoneLabel = ['iPhone', iphone[1], iphone[2]].filter(Boolean).join(' ');
      var iphoneGroups = [['iphone'], [iphone[1]]];
      if (iphone[2]) iphoneGroups.push([iphone[2]]);
      return { key: normalize(iphoneLabel), label: iphoneLabel, family: 'Apple iPhone', groups: iphoneGroups, variantGroups: iphoneGroups.slice(1) };
    }

    var fold = query.match(/(?:samsung\s*)?(?:galaxy\s*)?z\s*fold\s*(\d+)/);
    if (fold) {
      return {
        key: 'galaxy-z-fold-' + fold[1],
        label: 'Samsung Galaxy Z Fold ' + fold[1],
        family: 'Samsung Galaxy Z Fold',
        groups: [['samsung', 'galaxy'], ['fold'], [fold[1]]],
        variantGroups: [['fold'], [fold[1]]]
      };
    }

    var flip = query.match(/(?:samsung\s*)?(?:galaxy\s*)?z\s*flip\s*(\d+)/);
    if (flip) {
      return {
        key: 'galaxy-z-flip-' + flip[1],
        label: 'Samsung Galaxy Z Flip ' + flip[1],
        family: 'Samsung Galaxy Z Flip',
        groups: [['samsung', 'galaxy'], ['flip'], [flip[1]]],
        variantGroups: [['flip'], [flip[1]]]
      };
    }

    var galaxyPhone = query.match(/(?:samsung\s*)?(?:galaxy\s*)s\s*(\d+)\s*(ultra|plus|fe)?/);
    if (galaxyPhone) {
      var phoneSuffix = galaxyPhone[2] ? ' ' + galaxyPhone[2] : '';
      var phoneSignal = ['s' + galaxyPhone[1], 's ' + galaxyPhone[1]];
      return {
        key: 'galaxy-s-' + galaxyPhone[1] + phoneSuffix,
        label: 'Samsung Galaxy S' + galaxyPhone[1] + phoneSuffix,
        family: 'Samsung Galaxy phone',
        groups: [['samsung', 'galaxy'], phoneSignal].concat(galaxyPhone[2] ? [[galaxyPhone[2]]] : []),
        variantGroups: [phoneSignal].concat(galaxyPhone[2] ? [[galaxyPhone[2]]] : [])
      };
    }

    var galaxyNote = query.match(/^(?:samsung\s*)?(?:galaxy\s*)?note\s*(\d+)\s*(ultra|plus)?/);
    if (galaxyNote) {
      var noteSignal = ['note ' + galaxyNote[1], 'note' + galaxyNote[1]];
      var noteGroups = [['samsung', 'galaxy'], noteSignal];
      var noteVariants = [noteSignal];
      if (galaxyNote[2]) { noteGroups.push([galaxyNote[2]]); noteVariants.push([galaxyNote[2]]); }
      return { key: query, label: String(raw).trim(), family: 'Samsung Galaxy Note', groups: noteGroups, variantGroups: noteVariants };
    }

    var galaxyA = query.match(/^(?:samsung\s*)?(?:galaxy\s*)?a\s*(\d+)\s*(5g|4g)?/);
    if (galaxyA) {
      var aSignal = ['a' + galaxyA[1], 'a ' + galaxyA[1]];
      var aGroups = [['samsung', 'galaxy'], aSignal];
      var aVariants = [aSignal];
      if (galaxyA[2]) { aGroups.push([galaxyA[2]]); aVariants.push([galaxyA[2]]); }
      return { key: query, label: String(raw).trim(), family: 'Samsung Galaxy A', groups: aGroups, variantGroups: aVariants };
    }

    var pixelWatch = query.match(/(?:google\s*)?pixel\s*watch\s*(\d+)?\s*(\d{2})?\s*(?:mm)?/);
    if (pixelWatch) {
      var pixelWatchGroups = [['pixel'], ['watch']];
      var pixelWatchVariants = [['watch']];
      if (pixelWatch[1]) { pixelWatchGroups.push([pixelWatch[1]]); pixelWatchVariants.push([pixelWatch[1]]); }
      if (pixelWatch[2]) { pixelWatchGroups.push([pixelWatch[2], pixelWatch[2] + 'mm']); pixelWatchVariants.push([pixelWatch[2], pixelWatch[2] + 'mm']); }
      return { key: query, label: String(raw).trim(), family: 'Google Pixel Watch', groups: pixelWatchGroups, variantGroups: pixelWatchVariants };
    }

    var pixelPhone = query.match(/(?:google\s*)?pixel\s*(\d+[a-z]?)\s*(pro xl|pro|xl|fold|a)?/);
    if (pixelPhone) {
      var pixelSignal = ['pixel ' + pixelPhone[1], 'pixel' + pixelPhone[1]];
      var pixelGroups = [['pixel'], [pixelPhone[1], pixelSignal[0], pixelSignal[1]]];
      var pixelVariants = [[pixelPhone[1], pixelSignal[0], pixelSignal[1]]];
      if (pixelPhone[2]) { pixelGroups.push([pixelPhone[2]]); pixelVariants.push([pixelPhone[2]]); }
      return { key: query, label: String(raw).trim(), family: 'Google Pixel phone', groups: pixelGroups, variantGroups: pixelVariants };
    }

    if (/(?:motorola\s*)?razr\s*fold\b/.test(query)) {
      return {
        key: 'motorola-razr-fold',
        label: 'Motorola Razr Fold',
        family: 'Motorola Razr',
        groups: [['razr'], ['fold']],
        variantGroups: [['fold']]
      };
    }

    var razr = query.match(/(?:motorola\s*)?razr\s*(plus\s*)?(\d{2,4})\s*(ultra|plus)?/);
    if (razr) {
      var razrGroups = [['razr'], [razr[2]]];
      var razrVariants = [[razr[2]]];
      if (razr[1] || razr[3]) { razrGroups.push([razr[3] || 'plus']); razrVariants.push([razr[3] || 'plus']); }
      return { key: query, label: String(raw).trim(), family: 'Motorola Razr', groups: razrGroups, variantGroups: razrVariants };
    }

    var onePlus = query.match(/oneplus\s*(\d+)\s*(pro|r)?/);
    if (onePlus) {
      var onePlusGroups = [['oneplus'], [onePlus[1]]];
      var onePlusVariants = [[onePlus[1]]];
      if (onePlus[2]) { onePlusGroups.push([onePlus[2]]); onePlusVariants.push([onePlus[2]]); }
      return { key: query, label: String(raw).trim(), family: 'OnePlus', groups: onePlusGroups, variantGroups: onePlusVariants };
    }

    var galaxyWatchUltra = query.match(/(?:samsung\s*)?(?:galaxy\s*)?watch\s*ultra\b(.*)/);
    if (galaxyWatchUltra) {
      var ultraNumbers = (galaxyWatchUltra[1].match(/\d{1,2}(?:\s*mm)?/g) || []).map(function (value) { return value.replace(/\D/g, ''); });
      var ultraGeneration = ultraNumbers.find(function (number) { return Number(number) < 10; });
      var ultraSize = ultraNumbers.find(function (number) { return Number(number) >= 38; });
      var ultraGroups = [['samsung', 'galaxy'], ['watch'], ['ultra']];
      var ultraVariants = [['ultra']];
      if (ultraGeneration) { ultraGroups.push([ultraGeneration]); ultraVariants.push([ultraGeneration]); }
      if (ultraSize) { ultraGroups.push([ultraSize, ultraSize + 'mm']); ultraVariants.push([ultraSize, ultraSize + 'mm']); }
      return {
        key: query,
        label: String(raw).trim(),
        family: 'Samsung Galaxy Watch',
        groups: ultraGroups,
        variantGroups: ultraVariants,
        ambiguity: ultraSize ? null : 'Confirm the Galaxy Watch Ultra case size in millimeters before comparing exact-fit accessories.'
      };
    }

    var galaxyWatch = query.match(/(?:samsung\s*)?(?:galaxy\s*)watch\s*(\d+)\s*(classic|pro|ultra)?\s*(\d{2})?\s*(?:mm)?/);
    if (galaxyWatch) {
      var watchDetail = [galaxyWatch[2], galaxyWatch[3] ? galaxyWatch[3] + 'mm' : ''].filter(Boolean).join(' ');
      var galaxyWatchGroups = [['samsung', 'galaxy'], ['watch'], [galaxyWatch[1]]];
      var galaxyWatchVariantGroups = [[galaxyWatch[1]]];
      if (galaxyWatch[2]) { galaxyWatchGroups.push([galaxyWatch[2]]); galaxyWatchVariantGroups.push([galaxyWatch[2]]); }
      if (galaxyWatch[3]) { galaxyWatchGroups.push([galaxyWatch[3], galaxyWatch[3] + 'mm']); galaxyWatchVariantGroups.push([galaxyWatch[3], galaxyWatch[3] + 'mm']); }
      return {
        key: normalize('galaxy watch ' + galaxyWatch[1] + ' ' + watchDetail),
        label: 'Samsung Galaxy Watch ' + galaxyWatch[1] + (watchDetail ? ' ' + watchDetail : ''),
        family: 'Samsung Galaxy Watch',
        groups: galaxyWatchGroups,
        variantGroups: galaxyWatchVariantGroups
      };
    }

    if (query.indexOf('apple watch') !== -1) {
      var watchFamilyMatch = query.match(/apple\s*watch\s*(ultra|series|se)?/);
      var watchFamily = watchFamilyMatch && watchFamilyMatch[1];
      var watchSizeMatch = query.match(/\b(3[8-9]|4[0-9])\s*(?:mm)?\b/);
      var watchSize = watchSizeMatch && watchSizeMatch[1];
      var seriesMatch = query.match(/\bseries\s*(\d+)\b/);
      var ultraMatch = query.match(/\bultra\s*([1-9])\b/);
      var watchGeneration = (seriesMatch && seriesMatch[1]) || (ultraMatch && ultraMatch[1]);
      var watchParts = ['Apple Watch', watchFamily, watchGeneration, watchSize ? watchSize + 'mm' : ''].filter(Boolean);
      var awGroups = [['apple watch', 'iwatch']];
      var awVariants = [];
      if (watchFamily) { awGroups.push([watchFamily]); awVariants.push([watchFamily]); }
      if (watchGeneration) { awGroups.push([watchGeneration]); awVariants.push([watchGeneration]); }
      if (watchSize) { awGroups.push([watchSize, watchSize + 'mm']); awVariants.push([watchSize, watchSize + 'mm']); }
      return {
        key: normalize(watchParts.join(' ')),
        label: watchParts.join(' '),
        family: 'Apple Watch',
        groups: awGroups,
        variantGroups: awVariants,
        ambiguity: watchSize ? null : 'What is the watch case size in millimeters? Apple Watch fit can change by case size.'
      };
    }

    if (query.indexOf('ipad') !== -1) {
      var ipadFamilyMatch = query.match(/ipad\s+(air|pro|mini)\b/);
      var ipadFamily = ipadFamilyMatch && ipadFamilyMatch[1];
      var explicitGenerationMatch = query.match(/\b(\d+)(?:st|nd|rd|th)\s*(?:generation|gen)?\b/);
      var familyGenerationMatch = query.match(/ipad\s+(?:air|mini)\s+(\d+)\b/);
      var generationMatch = explicitGenerationMatch || familyGenerationMatch || query.match(/\b(?:generation|gen)\s*(\d+)\b/);
      var generation = generationMatch && generationMatch[1];
      var sizeMatch = query.match(/\b(\d{1,2}(?:\.\d+)?)\s*(?:inch|in)\b/) || query.match(/\b(7\.9|8\.3|9\.7|10\.2|10\.5|10\.9|11|12\.9|13)\b/);
      var size = sizeMatch && sizeMatch[1];
      var yearMatch = query.match(/\b(20\d{2})\b/);
      var year = yearMatch && yearMatch[1];
      var chipMatch = query.match(/\b(m\d+)\b/);
      var chip = chipMatch && chipMatch[1];
      var ipadGroups = [['ipad']];
      if (ipadFamily) ipadGroups.push([ipadFamily]);
      if (generation) ipadGroups.push((familyGenerationMatch ? [generation] : []).concat([generation + 'st', generation + 'nd', generation + 'rd', generation + 'th', generation + ' generation', generation + ' gen', 'gen ' + generation]));
      if (size) ipadGroups.push([size, size.replace('.', ' '), size + ' inch']);
      if (year) ipadGroups.push([year]);
      if (chip) ipadGroups.push([chip]);
      return {
        key: query,
        label: String(raw).trim(),
        family: 'Apple iPad',
        deviceKind: 'ipad',
        ipadFamily: ipadFamily || '',
        ipadGeneration: generation || '',
        ipadSize: size || '',
        ipadYear: year || '',
        ipadChip: chip || '',
        groups: ipadGroups,
        variantGroups: ipadGroups.slice(1),
        ambiguity: (!generation && !year && !chip) || (!ipadFamily && size && !generation && !year && !chip)
          ? 'Which iPad family and generation or model year is it? Screen size or family alone is not enough for an exact fit.'
          : null
      };
    }

    var galaxyTab = query.match(/(?:samsung\s*)?(?:galaxy\s*)?tab\s*([a-z]+\s*\d+)(?:\s*(lite|ultra|plus|fe))?/);
    if (galaxyTab) {
      var tabModel = galaxyTab[1].replace(/\s+/g, '');
      var tabModelSignals = [tabModel, galaxyTab[1]];
      var tabCodes = query.match(/\b(?:sm\s*)?[a-z]\d{3,4}[a-z]?\b/g) || [];
      var tabSize = (query.match(/\b(7\.0|8\.0|8\.4|8\.7|9\.7|10\.1|10\.4|10\.5|10\.9|11|12\.4|12\.9|14\.6)\b/) || [])[1];
      var tabGroups = [['galaxy tab', 'samsung tab', 'tab'], tabModelSignals];
      var tabVariants = [tabModelSignals];
      if (galaxyTab[2]) { tabGroups.push([galaxyTab[2]]); tabVariants.push([galaxyTab[2]]); }
      if (tabCodes.length) { tabGroups.push(tabCodes); tabVariants.push(tabCodes); }
      else if (tabSize) { tabGroups.push([tabSize]); tabVariants.push([tabSize]); }
      return { key: query, label: String(raw).trim(), family: 'Samsung Galaxy Tab', groups: tabGroups, variantGroups: tabVariants };
    }

    var surface = query.match(/surface\s*(pro|laptop|go|book)?\s*(x|\d+)?\s*(\d{2}(?:\.\d)?)?/);
    if (surface) {
      var surfaceGroups = [['surface']];
      if (surface[1]) surfaceGroups.push([surface[1]]);
      if (surface[2]) surfaceGroups.push([surface[2]]);
      if (surface[3]) surfaceGroups.push([surface[3], surface[3] + ' inch']);
      return {
        key: query,
        label: String(raw).trim(),
        family: 'Microsoft Surface',
        groups: surfaceGroups,
        variantGroups: surfaceGroups.slice(1),
        ambiguity: surface[1] && surface[2] ? null : 'Which Surface family, generation and screen size is it?'
      };
    }

    var garmin = query.match(/garmin\s*(.*?)(\d{2})?\s*(?:mm)?$/);
    if (garmin) {
      var garminDetail = normalize(garmin[1] || '');
      var width = garmin[2];
      var garminGroups = [['garmin']];
      if (garminDetail) garminGroups.push([garminDetail]);
      if (width) garminGroups.push([width, width + 'mm']);
      return {
        key: query,
        label: String(raw).trim(),
        family: 'Garmin',
        groups: garminGroups,
        variantGroups: garminGroups.slice(1),
        ambiguity: garminDetail || width ? null : 'Which Garmin model or connector width do you have?'
      };
    }

    var fitbit = query.match(/fitbit\s*(.*)/);
    if (fitbit) {
      var fitbitDetail = normalize(fitbit[1] || '');
      return {
        key: query,
        label: String(raw).trim(),
        family: 'Fitbit',
        groups: [['fitbit']].concat(fitbitDetail ? [[fitbitDetail]] : []),
        variantGroups: fitbitDetail ? [[fitbitDetail]] : [],
        ambiguity: fitbitDetail ? null : 'Which Fitbit model family do you have?'
      };
    }

    var genericWatch = query.match(/(amazfit|suunto|fossil)\s+(.+)/);
    if (genericWatch) {
      return {
        key: query,
        label: String(raw).trim(),
        family: titleCaseDevice(genericWatch[1]),
        groups: [[genericWatch[1]], [genericWatch[2]]],
        variantGroups: [[genericWatch[2]]]
      };
    }

    var macBook = query.match(/(?:apple\s*)?macbook\s*(air|pro)?\s*(\d{2}(?:\.\d)?)?\s*(?:inch)?\s*(m\d(?:\s*(?:pro|max|ultra))?)?/);
    if (macBook) {
      var macGroups = [['macbook']];
      var macVariants = [];
      if (macBook[1]) { macGroups.push([macBook[1]]); macVariants.push([macBook[1]]); }
      if (macBook[2]) { macGroups.push([macBook[2], macBook[2] + ' inch']); macVariants.push([macBook[2], macBook[2] + ' inch']); }
      if (macBook[3]) { macGroups.push([macBook[3]]); macVariants.push([macBook[3]]); }
      return { key: query, label: String(raw).trim(), family: 'Apple MacBook', groups: macGroups, variantGroups: macVariants, ambiguity: macVariants.length ? null : 'Which MacBook family, size or model code do you have?' };
    }

    return {
      key: query,
      label: String(raw).trim(),
      family: 'Unknown device',
      groups: [],
      ambiguity: 'Enter the complete device family, model, generation and size—or a manufacturer model code.'
    };
  }

  function matchesStrictIpadVariant(product, variant, device) {
    if (device.deviceKind !== 'ipad') return null;

    var variantText = normalize(variant.title || '');
    var productTextValue = normalize(product.title || '');
    var variantIsGeneric = !variantText || variantText === 'default title';
    var fitText = variantIsGeneric ? normalize(productTextValue + ' ' + variantText) : variantText;
    if (!containsToken(fitText, 'ipad') && !containsToken(productTextValue, 'ipad')) return false;

    var familyMatch = fitText.match(/ipad\s+(air|pro|mini)\b/);
    if (!familyMatch && variantIsGeneric) familyMatch = productTextValue.match(/ipad\s+(air|pro|mini)\b/);
    if (device.ipadFamily && (!familyMatch || familyMatch[1] !== device.ipadFamily)) return false;

    if (device.ipadSize) {
      var sizePattern = new RegExp('\\bipad(?:\\s+(?:air|pro|mini))?\\s+' + device.ipadSize.replace('.', '\\.') + '(?:\\s*(?:inch|in))?\\b');
      if (!sizePattern.test(fitText)) return false;
    }
    if (device.ipadChip && !containsToken(fitText, device.ipadChip)) return false;
    if (device.ipadYear && !containsToken(fitText, device.ipadYear)) return false;
    if (device.ipadGeneration) {
      var generation = device.ipadGeneration;
      var generationPattern = new RegExp('\\b(?:' + generation + '(?:st|nd|rd|th)?(?:\\s+(?:generation|gen))?|gen\\s+' + generation + ')\\b');
      if (!generationPattern.test(fitText)) return false;
    }
    return true;
  }

  function matchesVariant(product, variant, device) {
    if (device && /\b(?:apple\s*watch|iwatch)\s*(?:series\s*12|ultra\s*4)\b|^(?:series\s*12|ultra\s*4)\b/i.test(String(device.label || ''))) return !!(window.AvonticWatchQualifiedFit && window.AvonticWatchQualifiedFit.matchVariant(product, variant, device).matched);
    if (!variant || !variant.available || !device || !device.groups.length || device.ambiguity) return false;
    var canonicalEngine = window.AvonticCompatibility;
    if (canonicalEngine && device.kind && device.kind !== 'unknown' && typeof canonicalEngine.matchVariant === 'function') {
      return canonicalEngine.matchVariant(product, variant, device).matched;
    }
    var strictIpadMatch = matchesStrictIpadVariant(product, variant, device);
    if (strictIpadMatch !== null) return strictIpadMatch;
    var text = productText(product, variant);
    var productMatches = device.groups.every(function (group) {
      return group.some(function (term) { return containsToken(text, term); });
    });
    if (!productMatches) return false;

    var sharedAccessory = /charg|power|dock|stand|keyboard|stylus|adapter|cable/i.test((product.product_type || '') + ' ' + product.title);
    var variantLooksDeviceSpecific = (product.variants || []).some(function (item) {
      return /watch|iphone|ipad|galaxy|surface|fold|fitbit|garmin|\b\d{2}mm\b|\b\d+(?:st|nd|rd|th)\b/i.test(item.title || '');
    });
    if ((sharedAccessory && !variantLooksDeviceSpecific) || !(device.variantGroups || []).length) return true;

    var variantScope = normalize(product.title + ' ' + variant.title);
    return device.variantGroups.every(function (group) {
      return group.some(function (term) { return containsToken(variantScope, term); });
    });
  }

  var MATCHING_VARIANT_CACHE = typeof WeakMap === 'function' ? new WeakMap() : null;

  function deviceSignature(device) {
    return [device.key || '', device.watchLaunchVersion || '', device.size || '', device.family || '', device.ambiguity || '', JSON.stringify(device.groups || []), JSON.stringify(device.variantGroups || [])].join('|');
  }

  function primeMatchingVariants(product, device, variants) {
    if (!MATCHING_VARIANT_CACHE || !device || !variants || !variants.length) return;
    var productCache = MATCHING_VARIANT_CACHE.get(product);
    if (!productCache) {
      productCache = new Map();
      MATCHING_VARIANT_CACHE.set(product, productCache);
    }
    var signature = deviceSignature(device);
    var existing = productCache.get(signature) || [];
    var byId = new Map();
    existing.concat(variants).forEach(function (variant) { byId.set(String(variant.id), variant); });
    productCache.set(signature, Array.from(byId.values()));
  }

  function matchingVariants(product, device) {
    if (!device) return [];
    if (!MATCHING_VARIANT_CACHE) return (product.variants || []).filter(function (variant) { return matchesVariant(product, variant, device); });

    var productCache = MATCHING_VARIANT_CACHE.get(product);
    if (!productCache) {
      productCache = new Map();
      MATCHING_VARIANT_CACHE.set(product, productCache);
    }
    var signature = deviceSignature(device);
    if (!productCache.has(signature)) {
      productCache.set(signature, (product.variants || []).filter(function (variant) { return matchesVariant(product, variant, device); }));
    }
    return productCache.get(signature);
  }

  function fitEvidence(product, variant, device) {
    if (device && /\b(?:apple\s*watch|iwatch)\s*(?:series\s*12|ultra\s*4)\b|^(?:series\s*12|ultra\s*4)\b/i.test(String(device.label || ''))) return window.AvonticWatchQualifiedFit ? window.AvonticWatchQualifiedFit.matchVariant(product, variant, device) : {matched:false,confidence:'none',reason:'Watch fit data is unavailable.',source:'',signals:[]};
    var canonicalEngine = window.AvonticCompatibility;
    if (canonicalEngine && device && device.kind && device.kind !== 'unknown' && typeof canonicalEngine.matchVariant === 'function') {
      return canonicalEngine.matchVariant(product, variant, device);
    }
    return {
      matched: true,
      confidence: device && device.code ? 'model-code' : 'exact',
      reason: 'The published purchasable option contains every required fit signal.',
      source: variant && variant.title || '',
      signals: []
    };
  }

  function money(value) {
    try {
      return new Intl.NumberFormat(DISPLAY_LOCALE, { style: 'currency', currency: DISPLAY_CURRENCY }).format(Number(value || 0));
    } catch (_error) {
      return Number(value || 0).toFixed(2) + ' ' + DISPLAY_CURRENCY;
    }
  }

  function productImage(product, variant) {
    return (variant && variant.featured_image && variant.featured_image.src) ||
      (product.image && product.image.src) ||
      (product.images && product.images[0] && product.images[0].src) || '';
  }

  function productUrl(product, variant) {
    return '/products/' + encodeURIComponent(product.handle) + (variant ? '?variant=' + encodeURIComponent(variant.id) : '');
  }

  function displaySafeText(value) {
    return String(value == null ? '' : value)
      .replace(/\bmilitary[\s-]*grade\b/gi, 'tested protection')
      .replace(/\bshockproof\b/gi, 'impact protection')
      .replace(/\bwaterproof\b/gi, 'water protection')
      .replace(/\bguarantee\b/gi, 'coverage')
      .replace(/\bunbreakable\b/gi, 'durable')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function categoryDisplayText(value, category) {
    var safe = displaySafeText(value);
    if (category !== 'watch-band') return safe;
    return safe
      .replace(/\bstraps\b/gi, 'bands')
      .replace(/\bstrap\b/gi, 'band')
      .replace(/\bbracelets\b/gi, 'bands')
      .replace(/\bbracelet\b/gi, 'band');
  }

  function materialValue(product, variant) {
    var text = productText(product, variant);
    var materials = [
      ['titanium', 'Titanium'], ['stainless steel', 'Stainless steel'],
      ['aramid fiber', 'Aramid fiber'], ['carbon fiber', 'Carbon fiber'],
      ['microfiber leather', 'Microfiber leather'], ['genuine leather', 'Genuine leather'],
      ['leather', 'Leather-style material'], ['braided nylon', 'Braided nylon'],
      ['nylon', 'Nylon'], ['silicone', 'Silicone'], ['polycarbonate', 'Polycarbonate'],
      ['tpu', 'TPU'], ['tempered glass', 'Tempered glass'], ['aluminum', 'Aluminum'],
      ['zinc alloy', 'Zinc alloy'], ['abs', 'ABS']
    ];
    var found = [];
    materials.forEach(function (pair) {
      if (text.indexOf(pair[0]) !== -1 && found.indexOf(pair[1]) === -1) found.push(pair[1]);
    });
    return found.length ? found.slice(0, 4).join(' + ') : '';
  }

  function claimIsNegated(text, start, end) {
    var before = text.slice(Math.max(0, start - 90), start);
    var after = text.slice(end, Math.min(text.length, end + 120));
    return /(?:\bno\b|\bnot\b|\bwithout\b|\bexcludes?\b|\bdoes not include\b)[a-z0-9 ]{0,55}$/.test(before) ||
      /^[a-z0-9 ]{0,48}\b(?:not included|not supplied|sold separately|is not included|are not included|does not include)\b/.test(after);
  }

  function claimValue(product, variant, patterns) {
    if (Array.isArray(variant)) {
      patterns = variant;
      variant = null;
    }
    var text = productText(product, variant);
    for (var i = 0; i < patterns.length; i += 1) {
      var pattern = patterns[i];
      var expression = Array.isArray(pattern) ? pattern[0] : pattern.pattern;
      var result = Array.isArray(pattern) ? pattern[1] : pattern.value;
      var offset = 0;
      var remaining = text;
      var match;
      expression.lastIndex = 0;
      while ((match = expression.exec(remaining))) {
        var absoluteStart = offset + match.index;
        var absoluteEnd = absoluteStart + match[0].length;
        if (!claimIsNegated(text, absoluteStart, absoluteEnd)) {
          var detail = typeof result === 'function' ? result(match, text) : result;
          return displaySafeText(detail == null ? match[0] : detail);
        }
        offset = absoluteEnd || offset + 1;
        remaining = text.slice(offset);
        expression.lastIndex = 0;
      }
    }
    return '';
  }

  function colorOptionsValue(product) {
    var options = Array.isArray(product.options) ? product.options : [];
    for (var optionIndex = 0; optionIndex < options.length; optionIndex += 1) {
      var option = options[optionIndex];
      var optionName = typeof option === 'string' ? option : option.name;
      if (!/\bcolou?r\b/.test(normalize(optionName))) continue;
      var values = typeof option === 'object' && Array.isArray(option.values)
        ? option.values
        : (product.variants || []).map(function (variant) { return variant['option' + (optionIndex + 1)]; });
      var distinct = [];
      values.forEach(function (value) {
        var key = normalize(value);
        if (key && distinct.indexOf(key) === -1) distinct.push(key);
      });
      return distinct.length ? distinct.length + (distinct.length === 1 ? ' color' : ' colors') : '';
    }
    return '';
  }

  function savingsValue(_product, variant) {
    var price = Number(variant && variant.price);
    var compareAt = Number(variant && variant.compare_at_price);
    if (!(compareAt > price)) return '';
    var savings = compareAt - price;
    var percent = Math.round((savings / compareAt) * 100);
    return money(savings) + ' (' + percent + '%)';
  }

  function warrantyValue(product, variant) {
    function formatDuration(match) {
      var unit = match[2].indexOf('year') === 0 ? 'Year' : 'Month';
      return match[1] + '-' + unit + ' Warranty';
    }
    return claimValue(product, variant, [
      [/\b(\d{1,3})\s*(month|months|year|years)\s*warranty\b/, formatDuration],
      [/\bwarranty\s*(?:of|for)?\s*(\d{1,3})\s*(month|months|year|years)\b/, formatDuration]
    ]);
  }

  function wristSizeValue(product, variant) {
    return claimValue(product, variant, [
      [/(?:wrist size|fits? wrists?|wrist circumference)[a-z0-9 ]{0,28}\b(\d{2,3})\s+(?:to\s+)?(\d{2,3})\s*mm\b/, function (match) { return match[1] + '–' + match[2] + ' mm'; }],
      [/\b(\d{2,3})\s+(?:to\s+)?(\d{2,3})\s*mm\b[a-z0-9 ]{0,18}(?:wrist|circumference)/, function (match) { return match[1] + '–' + match[2] + ' mm'; }],
      [/(?:wrist size|fits? wrists?|wrist circumference)[a-z0-9 ]{0,28}\b(\d{1,2})\s+(?:to\s+)?(\d{1,2})\s*(?:in|inch|inches)\b/, function (match) { return match[1] + '–' + match[2] + ' in'; }]
    ]);
  }

  function batteryLifeValue(product, variant) {
    return claimValue(product, variant, [
      [/(?:battery life|runtime|working time)[a-z0-9 ]{0,20}(?:up to\s*)?(\d{1,4})\s*(hour|hours|hr|hrs|day|days|month|months)\b/, function (match) {
        var unit = match[2].indexOf('hour') === 0 || match[2].indexOf('hr') === 0 ? 'hours' : (match[2].indexOf('day') === 0 ? 'days' : 'months');
        return 'Up to ' + match[1] + ' ' + unit;
      }],
      [/\b(\d{1,4})\s*(hour|hours|hr|hrs|day|days|month|months)\s*(?:battery life|runtime|working time)\b/, function (match) {
        var unit = match[2].indexOf('hour') === 0 || match[2].indexOf('hr') === 0 ? 'hours' : (match[2].indexOf('day') === 0 ? 'days' : 'months');
        return match[1] + ' ' + unit;
      }]
    ]);
  }

  var UNIVERSAL_ROWS = [
    { label: 'Selected exact-fit variant', group: 'Compatibility', kind: 'text', value: function (_p, v) { return v.title || ''; } },
    { label: 'Live price', group: 'Purchase', kind: 'text', value: function (_p, v) { return money(v.price); } },
    { label: 'You save', group: 'Purchase', kind: 'text', value: savingsValue },
    { label: 'Availability', group: 'Purchase', kind: 'text', value: function (_p, v) { return v.available ? 'Available' : 'Unavailable'; } },
    { label: 'Materials', group: 'Construction', kind: 'text', value: materialValue },
    { label: 'Color options', group: 'Construction', kind: 'text', value: colorOptionsValue },
    { label: 'Model-specific fit', group: 'Compatibility', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/precision cutouts?|exact cutouts?/, 'precision cutouts'], [/model specific fit|precision fit|exact fit/, 'model-specific fit']]); } },
    { label: 'Warranty', group: 'Support', kind: 'text', value: warrantyValue },
    { label: 'Returns', group: 'Support', kind: 'text', value: function () { return '60-Day Returns'; } }
  ];

  var CATEGORY_ROWS = {
    'tablet-case': [
      { label: 'Multi-layer protection', group: 'Protection', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/triple layer/, 'triple-layer protection'], [/dual layer/, 'dual-layer protection'], [/multi layer/, 'multi-layer protection']]); } },
      { label: 'Reinforced corners', group: 'Protection', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/airbag corners?/, 'airbag corner protection'], [/reinforced corners?/, 'reinforced corners'], [/corner bumpers?/, 'corner bumpers']]); } },
      { label: 'Rugged build', group: 'Protection', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/heavy duty/, 'heavy-duty build'], [/rugged/, 'rugged build']]); } },
      { label: 'Screen protection', group: 'Protection', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/built in screen(?: protector| cover)?/, 'built-in screen protector'], [/integrated screen(?: protector| layer)?/, 'integrated screen protection'], [/tempered glass/, 'tempered glass protection'], [/raised screen|raised edges?/, 'raised screen edges']]); } },
      { label: 'Kickstand', group: 'Utility', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/360(?: degree)? rotating kickstand|360 rotating stand/, '360° rotating kickstand'], [/multi angle(?: kickstand| stand)?/, 'multi-angle kickstand'], [/built in kickstand/, 'built-in kickstand'], [/integrated stand|kickstand/, 'integrated kickstand']]); } },
      { label: 'Hand strap', group: 'Utility', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/padded hand strap/, 'padded hand strap'], [/360(?: degree)? rotating hand strap|rotating hand strap/, '360° rotating hand strap'], [/hand strap/, 'hand strap']]); } },
      { label: 'Shoulder strap', group: 'Utility', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/detachable shoulder strap/, 'detachable shoulder strap'], [/shoulder strap/, 'shoulder strap']]); } },
      { label: 'Stylus/Pencil storage', group: 'Utility', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/stylus storage/, 'integrated stylus storage'], [/pencil holder/, 'integrated Pencil holder'], [/pencil storage/, 'integrated Pencil storage']]); } },
      { label: 'Pencil charging supported', group: 'Connectivity', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/pencil charging/, 'Pencil charging supported'], [/charge through/, 'charge-through support']]); } },
      { label: 'Keyboard compatible', group: 'Connectivity', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/keyboard compatible|compatible with (?:a )?keyboard|keyboard support/, 'keyboard compatible']]); } },
      { label: 'Magnetic closure', group: 'Utility', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/magnetic closure/, 'magnetic closure']]); } },
      { label: 'Camera protection', group: 'Protection', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/camera guard/, 'camera guard'], [/raised camera(?: edge| lip| bezel)?/, 'raised camera protection']]); } },
      { label: 'Full port access', group: 'Compatibility', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/full port access|port access|full access/, 'full port access'], [/precision cutouts?/, 'precision-cutout access']]); } },
      { label: 'Slim profile', group: 'Construction', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/low profile/, 'low-profile design'], [/lightweight/, 'lightweight design'], [/slim/, 'slim profile']]); } }
    ],
    'phone-case': [
      { label: 'MagSafe / Qi2', group: 'Connectivity', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/qi2/, 'Qi2 compatible'], [/magsafe/, 'MagSafe compatible']]); } },
      { label: 'Kickstand', group: 'Utility', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/360(?: degree)? rotating kickstand|360 rotating stand/, '360° rotating kickstand'], [/multi angle(?: kickstand| stand)?/, 'multi-angle kickstand'], [/built in kickstand/, 'built-in kickstand'], [/kickstand|integrated stand/, 'integrated kickstand']]); } },
      { label: 'Camera protection', group: 'Protection', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/camera guard/, 'camera guard'], [/raised camera(?: edge| lip| bezel)?/, 'raised camera protection']]); } },
      { label: 'Raised screen edges', group: 'Protection', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/raised screen|raised edges?/, 'raised screen edges']]); } },
      { label: 'Card/wallet storage', group: 'Utility', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/card slots?/, 'card storage'], [/wallet/, 'wallet storage']]); } },
      { label: 'Detachable design', group: 'Utility', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/detachable/, 'detachable design']]); } },
      { label: 'Grip texture', group: 'Utility', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/anti slip/, 'anti-slip grip'], [/textured/, 'textured grip'], [/\bgrip\b/, 'enhanced grip']]); } },
      { label: 'Rugged build', group: 'Protection', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/heavy duty/, 'heavy-duty build'], [/rugged/, 'rugged build']]); } },
      { label: 'Multi-layer protection', group: 'Protection', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/triple layer/, 'triple-layer protection'], [/dual layer/, 'dual-layer protection'], [/multi layer/, 'multi-layer protection']]); } },
      { label: 'Slim profile', group: 'Construction', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/low profile/, 'low-profile design'], [/lightweight/, 'lightweight design'], [/slim/, 'slim profile']]); } }
    ],
    'watch-band': [
      { label: 'Accessory material detail', group: 'Construction', kind: 'text', value: materialValue },
      { label: 'Clasp type', group: 'Utility', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/butterfly(?: style)? clasp/, 'butterfly clasp'], [/folding clasp/, 'folding clasp'], [/magnetic clasp/, 'magnetic clasp'], [/secure metal clasp/, 'secure metal clasp'], [/\bbuckle\b/, 'buckle clasp']]); } },
      { label: 'Quick-release pins', group: 'Utility', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/quick release pins?|quick release/, 'quick-release pins']]); } },
      { label: 'Link adjustment / sizing tool included', group: 'Utility', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/(?:sizing|adjustment|link removal) tool included|included (?:band )?(?:link )?(?:adjustment|sizing|link removal) tool|includes? (?:an? )?(?:band )?(?:link )?(?:adjustment|sizing|link removal) tool/, 'sizing tool included'], [/link adjustment|adjustable links|removable links|adjust links|resize (?:the )?band/, 'link adjustment supported']]); } },
      { label: 'Case included', group: 'Utility', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/band case set|case included|with case|band (?:and|with) (?:an? )?(?:armor |protective )?case|band and protection set/, 'matching case included']]); } },
      { label: 'Screen protection', group: 'Protection', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/built in screen(?: protector| cover)?/, 'built-in screen protector'], [/integrated screen(?: protector| layer)?/, 'integrated screen protection'], [/tempered glass/, 'tempered glass protection'], [/raised screen|raised edges?/, 'raised screen edges']]); } },
      { label: 'Fits wrist sizes', group: 'Compatibility', kind: 'text', value: wristSizeValue },
      { label: 'Sweat & workout ready', group: 'Utility', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/sweat and workout|sweat resistant|sweatproof|workout|gym/, 'sweat and workout ready']]); } }
    ],
    'keyboard-case': [
      { label: 'Backlit keys', group: 'Utility', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/backlit keys?|backlit keyboard|keyboard backlight/, 'backlit keys']]); } },
      { label: 'Trackpad', group: 'Utility', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/trackpad|touchpad/, 'integrated trackpad']]); } },
      { label: 'Connection type', group: 'Connectivity', kind: 'text', value: function (p, v) { return claimValue(p, v, [[/smart connector/, 'Smart Connector'], [/bluetooth/, 'Bluetooth']]); } },
      { label: 'Battery life claim', group: 'Utility', kind: 'text', value: batteryLifeValue },
      { label: 'Adjustable viewing angles', group: 'Utility', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/\b(\d{1,2})\s*(?:adjustable )?(?:viewing )?angles\b/, function (match) { return match[1] + ' viewing angles'; }], [/multi angle|adjustable angle|adjustable viewing/, 'adjustable viewing angles']]); } },
      { label: 'Detachable keyboard', group: 'Utility', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/detachable keyboard/, 'detachable keyboard']]); } }
    ],
    'charging': [
      { label: 'Output wattage', group: 'Connectivity', kind: 'text', value: function (p, v) { return claimValue(p, v, [[/\b(\d{1,3})\s*w\b/, function (match) { return match[1] + 'W'; }]]); } },
      { label: 'Devices charged simultaneously', group: 'Utility', kind: 'text', value: function (p, v) { return claimValue(p, v, [[/\b(\d{1,2})\s*in\s*1\b/, function (match) { return match[1] + '-in-1 charging'; }], [/(?:charges?|charging)\s*(\d{1,2})\s*devices?/, function (match) { return match[1] + ' devices'; }]]); } },
      { label: 'Foldable / travel design', group: 'Utility', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/foldable|travel design|travel ready|portable/, 'foldable travel design']]); } },
      { label: 'Cable included', group: 'Connectivity', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/usb c cable included|includes usb c cable/, 'USB-C cable included'], [/cable included|includes cable/, 'charging cable included']]); } },
      { label: 'MagSafe / Qi2', group: 'Connectivity', kind: 'boolean', value: function (p, v) { return claimValue(p, v, [[/qi2/, 'Qi2 compatible'], [/magsafe/, 'MagSafe compatible']]); } }
    ],
    'general': []
  };

  function detectComparisonCategory(device, details) {
    var deviceText = normalize([device && device.label, device && device.family, device && device.category].join(' '));
    var productTextOnly = normalize((details || []).map(function (item) {
      return [item.product.product_type, item.product.title].join(' ');
    }).join(' '));
    var combined = deviceText + ' ' + productTextOnly;
    if (/\bcharg(?:e|er|ing)|charging station|power bank|wireless charger\b/.test(productTextOnly)) return 'charging';
    if (/\bkeyboard\b/.test(productTextOnly)) return 'keyboard-case';
    if (/\bwatch\b|\bfitbit\b|\bgarmin\b|\bamazfit\b|\bsuunto\b|\bfossil\b/.test(deviceText) ||
        /\bwatch band\b|\bwatch strap\b|\bbracelet\b|\bfitbit\b|\bgarmin\b/.test(productTextOnly)) return 'watch-band';
    if (/\bipad\b|\btablet\b|\bgalaxy tab\b|\bsurface\b/.test(combined)) return 'tablet-case';
    if (/\biphone\b|\bphone\b|\bgalaxy (?:s|a|note|z fold|z flip)\b|\bpixel\b|\brazr\b|\boneplus\b/.test(combined)) return 'phone-case';
    return 'general';
  }

  function comparisonRows(category) {
    return UNIVERSAL_ROWS.concat(CATEGORY_ROWS[category] || CATEGORY_ROWS.general);
  }

  function rawRowValue(row, product, variant) {
    var value = row.value(product, variant);
    return value == null ? '' : String(value).trim();
  }

  function rowComparisonKey(value, category) {
    var display = categoryDisplayText(value, category);
    return display ? normalize(display) : 'no';
  }

  function formatRowCell(row, value, category) {
    var display = categoryDisplayText(value, category);
    if (row.kind === 'boolean') {
      return display
        ? { text: '✓ ' + display, className: 'avcs-cell--yes' }
        : { text: '✗ No', className: 'avcs-cell--no' };
    }
    return { text: display || '—', className: display ? 'avcs-cell--text' : 'avcs-cell--empty' };
  }

  function filterMatch(product, activeFilter) {
    if (activeFilter === 'all') return true;
    var map = {
      protective: /rugged|heavy duty|shockproof|reinforced|armor/,
      stand: /kickstand|integrated stand|viewing stand/,
      work: /work|field|jobsite|keyboard|hand strap/,
      travel: /travel|shoulder strap|foldable|portable/,
      metal: /titanium|stainless steel|metal/,
      leather: /leather/
    };
    return map[activeFilter] ? map[activeFilter].test(productText(product)) : true;
  }

  function scoreProduct(product, variant, priority, lowestPrice) {
    var text = productText(product, variant);
    var tests = {
      protection: /rugged|heavy duty|reinforced|multi layer|shockproof|military/g,
      materials: /titanium|genuine leather|stainless steel|premium material|carbon fiber/g,
      stand: /360.*(?:kickstand|stand)|portrait.*landscape|multi angle/g,
      travel: /travel|foldable|shoulder strap|portable/g,
      work: /work|jobsite|field|keyboard|hand strap|presentation/g,
      outdoor: /outdoor|rugged|military|shockproof|water resistant/g,
      minimal: /slim|lightweight|minimal|clear|low profile/g
    };
    if (priority === 'value') return Number(variant.price) === lowestPrice ? 5 : Math.max(0, 4 - Number(variant.price) / 50);
    return tests[priority] ? ((text.match(tests[priority]) || []).length) : 0;
  }

  function track(eventName, detail) {
    var data = Object.assign({ event: eventName }, detail || {});
    try {
      if (window.AvonticAnalytics && typeof window.AvonticAnalytics.track === 'function') {
        window.AvonticAnalytics.track(eventName, detail || {});
      }
    } catch (_error) {}
    window.dispatchEvent(new CustomEvent('avontic:compare', { detail: data }));
  }

  function init(root) {
    if (!root || root.dataset.avcsReady === 'true') return;
    root.dataset.avcsReady = 'true';
    DISPLAY_CURRENCY = root.dataset.currency || DISPLAY_CURRENCY;
    DISPLAY_LOCALE = root.dataset.locale || DISPLAY_LOCALE;

    var state = {
      catalog: [],
      deviceOptions: [],
      catalogVariantCount: 0,
      device: null,
      compatible: [],
      selectedHandles: [],
      selectedVariants: {},
      filter: 'all',
      priority: 'protection',
      differencesOnly: false,
      dialogHandle: null
    };

    var els = {
      queryInputs: root.querySelectorAll('[data-avcs-query]'),
      searchForms: root.querySelectorAll('[data-avcs-search-form]'),
      searchSubmit: root.querySelector('[data-avcs-search-submit]'),
      loading: root.querySelector('[data-avcs-loading]'),
      count: root.querySelector('[data-avcs-catalog-count]'),
      orbit: root.querySelector('[data-avcs-orbit-products]'),
      quick: root.querySelector('[data-avcs-quick-devices]'),
      category: root.querySelector('[data-avcs-category]'),
      brand: root.querySelector('[data-avcs-brand]'),
      model: root.querySelector('[data-avcs-model]'),
      modelCount: root.querySelector('[data-avcs-model-count]'),
      confirmModel: root.querySelector('[data-avcs-confirm-model]'),
      results: root.querySelector('[data-avcs-results]'),
      confirmation: root.querySelector('[data-avcs-confirmation]'),
      identity: root.querySelector('[data-avcs-identity]'),
      resultsHeading: root.querySelector('[data-avcs-results-heading]'),
      syncTime: root.querySelector('[data-avcs-sync-time]'),
      filters: root.querySelector('[data-avcs-filters]'),
      products: root.querySelector('[data-avcs-products]'),
      compare: root.querySelector('[data-avcs-compare]'),
      priorities: root.querySelector('[data-avcs-priorities]'),
      recommendation: root.querySelector('[data-avcs-recommendation]'),
      table: root.querySelector('[data-avcs-table]'),
      differences: root.querySelector('[data-avcs-differences]'),
      share: root.querySelector('[data-avcs-share]'),
      save: root.querySelector('[data-avcs-save]'),
      addAll: root.querySelector('[data-avcs-add-all]'),
      selectedCount: root.querySelector('[data-avcs-selected-count]'),
      mobileBar: root.querySelector('[data-avcs-mobile-bar]'),
      mobileCount: root.querySelector('[data-avcs-mobile-count]'),
      mobileAdd: root.querySelector('[data-avcs-mobile-add]'),
      dialog: root.querySelector('[data-avcs-dialog]'),
      dialogContent: root.querySelector('[data-avcs-dialog-content]'),
      closeDialog: root.querySelector('[data-avcs-close-dialog]'),
      toast: root.querySelector('[data-avcs-toast]')
    };

    function notify(message) {
      els.toast.textContent = message;
      els.toast.hidden = false;
      window.clearTimeout(notify.timer);
      notify.timer = window.setTimeout(function () { els.toast.hidden = true; }, 2800);
    }

    function setQueries(value) {
      els.queryInputs.forEach(function (input) { input.value = value; });
    }

    function unique(values) {
      return values.filter(function (value, index) { return values.indexOf(value) === index; });
    }

    function fillSelect(select, values, current) {
      select.innerHTML = values.map(function (value) { return '<option' + (value === current ? ' selected' : '') + '>' + escapeHtml(value) + '</option>'; }).join('');
    }

    function renderGuidedDevice() {
      if (!state.deviceOptions.length) {
        fillSelect(els.category, ['Synchronizing…'], 'Synchronizing…');
        fillSelect(els.brand, ['Live catalog'], 'Live catalog');
        fillSelect(els.model, ['Models loading'], 'Models loading');
        els.category.disabled = true;
        els.brand.disabled = true;
        els.model.disabled = true;
        els.confirmModel.disabled = true;
        return;
      }
      els.category.disabled = false;
      els.brand.disabled = false;
      els.model.disabled = false;
      els.confirmModel.disabled = false;
      var categories = unique(state.deviceOptions.map(function (item) { return item.category; }));
      var currentCategory = categories.indexOf(els.category.value) !== -1 ? els.category.value : categories[0];
      fillSelect(els.category, categories, currentCategory);
      var brands = unique(state.deviceOptions.filter(function (item) { return item.category === currentCategory; }).map(function (item) { return item.brand; }));
      var currentBrand = brands.indexOf(els.brand.value) !== -1 ? els.brand.value : brands[0];
      fillSelect(els.brand, brands, currentBrand);
      var models = state.deviceOptions.filter(function (item) { return item.category === currentCategory && item.brand === currentBrand; }).map(function (item) { return item.label; });
      var currentModel = models.indexOf(els.model.value) !== -1 ? els.model.value : models[0];
      fillSelect(els.model, models, currentModel);
    }

    function renderQuickDevices() {
      els.quick.innerHTML = QUICK_DEVICES.map(function (label) {
        return '<button type="button" data-avcs-quick="' + escapeHtml(label) + '">' + escapeHtml(label) + '</button>';
      }).join('');
    }

    function renderOrbit() {
      var patterns = [/ipad/i, /titanium.*garmin|garmin.*titanium/i, /apple watch|obsidian/i, /iphone/i, /charg/i];
      var picks = [];
      patterns.forEach(function (pattern) {
        var product = state.catalog.find(function (item) { return pattern.test((item.product_type || '') + ' ' + item.title) && productImage(item); });
        if (product && picks.indexOf(product) === -1) picks.push(product);
      });
      state.catalog.some(function (product) {
        if (picks.length >= 5) return true;
        if (productImage(product) && picks.indexOf(product) === -1) picks.push(product);
        return picks.length >= 5;
      });
      els.orbit.innerHTML = picks.slice(0, 5).map(function (product) {
        return '<a class="avcs-orbit-product" href="' + productUrl(product) + '" aria-label="Open ' + escapeHtml(product.title) + '">' +
          '<img src="' + escapeHtml(productImage(product)) + '" alt="' + escapeHtml(product.title) + '" width="180" height="180">' +
        '</a>';
      }).join('');
    }

    function selectedDetails() {
      return state.selectedHandles.map(function (handle) {
        var product = state.catalog.find(function (item) { return item.handle === handle; });
        if (!product) return null;
        var variants = matchingVariants(product, state.device);
        var variant = variants.find(function (item) { return String(item.id) === String(state.selectedVariants[handle]); }) || variants[0];
        return variant ? { product: product, variant: variant } : null;
      }).filter(Boolean);
    }

    function syncUrl() {
      if (!state.device || state.device.ambiguity) return;
      var params = new URLSearchParams(window.location.search);
      params.set('device', state.device.label);
      if (state.selectedHandles.length) params.set('compare', state.selectedHandles.join(','));
      else params.delete('compare');
      window.history.replaceState({ device: state.device.label, compare: state.selectedHandles }, '', window.location.pathname + '?' + params.toString());
    }

    function applyDeviceNow(raw, restoreHandles) {
      var resolved = resolveDevice(raw);
      state.device = resolved;
      setQueries(raw);
      state.filter = 'all';
      var resolvedSignature = deviceSignature(resolved);
      var indexedOptions = state.deviceOptions.filter(function (item) {
        return deviceSignature(resolveDevice(item.label)) === resolvedSignature;
      });
      var sourceHandleSet = indexedOptions.length ? new Set() : null;
      indexedOptions.forEach(function (item) {
        item.sourceHandles.forEach(function (handle) { sourceHandleSet.add(handle); });
      });
      var candidateProducts = sourceHandleSet
        ? state.catalog.filter(function (product) { return sourceHandleSet.has(product.handle); })
        : state.catalog;
      state.compatible = resolved.ambiguity ? [] : candidateProducts.filter(function (product) { return matchingVariants(product, resolved).length > 0; });

      var restored = Array.isArray(restoreHandles)
        ? restoreHandles.filter(function (handle) { return state.compatible.some(function (product) { return product.handle === handle; }); }).slice(0, 4)
        : [];
      state.selectedHandles = restored.length ? restored : state.compatible.slice(0, 3).map(function (product) { return product.handle; });
      state.selectedVariants = {};
      state.selectedHandles.forEach(function (handle) {
        var product = state.compatible.find(function (item) { return item.handle === handle; });
        var variant = product && matchingVariants(product, resolved)[0];
        if (variant) state.selectedVariants[handle] = variant.id;
      });

      try { localStorage.setItem('avontic-device', raw); } catch (_error) {}
      track('compare_device_confirmed', { device: resolved.label, matches: state.compatible.length });
      if (!state.compatible.length && !resolved.ambiguity) track('compare_search_no_result', { query: raw });
      renderAll();
      syncUrl();
      window.setTimeout(function () { els.results.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' }); }, 60);
    }

    var deviceApplicationToken = 0;

    function applyDevice(raw, restoreHandles) {
      var token = ++deviceApplicationToken;
      var actionButtons = Array.from(root.querySelectorAll('[data-avcs-search-submit], [data-avcs-confirm-model]'));
      actionButtons.forEach(function (button) {
        if (!button.dataset.avcsIdleLabel) button.dataset.avcsIdleLabel = button.textContent;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = 'Finding exact matches…';
      });
      root.dataset.avcsMatching = 'true';

      var afterPaint = typeof window.requestAnimationFrame === 'function'
        ? function (callback) { window.requestAnimationFrame(callback); }
        : function (callback) { window.setTimeout(callback, 0); };
      afterPaint(function () {
        window.setTimeout(function () {
          if (token !== deviceApplicationToken) return;
          try {
            applyDeviceNow(raw, restoreHandles);
          } finally {
            actionButtons.forEach(function (button) {
              button.disabled = false;
              button.removeAttribute('aria-busy');
              button.textContent = button.dataset.avcsIdleLabel;
            });
            delete root.dataset.avcsMatching;
          }
        }, 0);
      });
    }

    function renderConfirmation() {
      var device = state.device;
      if (!device) return;
      els.results.hidden = false;
      els.confirmation.innerHTML =
        '<div class="avcs-confirmation__seal' + (device.ambiguity ? ' is-caution' : '') + '">' + (device.ambiguity ? '?' : '✓') + '</div>' +
        '<div><span>' + (device.ambiguity ? 'One detail needed' : device.watchLaunchModel ? 'Listed model matched' : 'Exact fit verified') + '</span>' +
        '<strong>' + escapeHtml(device.label) + '</strong>' +
        '<p>' + escapeHtml(device.ambiguity || (device.watchLaunchModel ? 'These available accessory options are listed for your exact watch model and size.' : 'Every result below includes a purchasable variant that passed the required exact-fit checks.')) + '</p></div>' +
        '<button type="button" data-avcs-change-device>Change device</button>';
      if (els.identity) {
        els.identity.hidden = !!device.ambiguity;
        if (!device.ambiguity) {
          var signalMarkup = (device.signals || []).map(function (signal) {
            return '<div><span>' + escapeHtml(signal.label) + '</span><strong>' + escapeHtml(signal.value) + '</strong></div>';
          }).join('');
          var fitGroup = device.fitGroup ? '<div><span>' + (device.watchLaunchModel ? 'Watch model group' : 'Verified fit group') + '</span><strong>' + escapeHtml(device.fitGroup.replace(/-/g, ' ')) + '</strong></div>' : '';
          els.identity.innerHTML = '<div class="avcs-identity__head"><p class="avcs-card-kicker">Canonical identity dossier</p><h3>' + escapeHtml(device.family) + '</h3><p>Every result below resolves to this device identity before price, material or availability is considered.</p></div>' +
            '<div class="avcs-identity__signals">' + signalMarkup + fitGroup + '</div>' +
            '<div class="avcs-identity__guard"><span>Hard exclusions</span><strong>Neighboring size, family, generation and edition variants are blocked.</strong></div>';
        }
      }
      els.resultsHeading.hidden = !!device.ambiguity;
      els.filters.hidden = !!device.ambiguity;
      els.products.hidden = !!device.ambiguity;
    }

    function renderFilters() {
      els.filters.innerHTML = FILTERS.map(function (pair) {
        return '<button type="button" data-avcs-filter="' + pair[0] + '" class="' + (state.filter === pair[0] ? 'is-active' : '') + '" aria-pressed="' + (state.filter === pair[0]) + '">' + escapeHtml(pair[0] === 'all' && state.device && state.device.watchLaunchModel ? 'All accessory matches' : pair[1]) + '</button>';
      }).join('');
    }

    function renderProducts() {
      if (!state.device || state.device.ambiguity) { els.products.innerHTML = ''; return; }
      var products = state.compatible.filter(function (product) { return filterMatch(product, state.filter); });
      if (!products.length) {
        els.products.innerHTML = '<div class="avcs-empty"><b>∅</b><h3>No published, available exact fit found.</h3><p>We will not substitute a neighboring model. Confirm the complete device identity or ask Avontic to verify it personally.</p><a href="' + escapeHtml(root.dataset.contactUrl || '/pages/contact-us') + '">Ask Avontic to verify your device</a></div>';
        return;
      }
      els.products.innerHTML = products.map(function (product) {
        var variants = matchingVariants(product, state.device);
        var variant = variants.find(function (item) { return String(item.id) === String(state.selectedVariants[product.handle]); }) || variants[0];
        var evidence = fitEvidence(product, variant, state.device);
        var evidenceLabel = evidence.confidence === 'standard-connector' ? 'Band connector matched' : evidence.confidence === 'listed-model' ? 'Listed model matched' : evidence.confidence === 'model-code' ? 'Model code verified' : evidence.confidence === 'verified-alias' ? 'Equivalent fit verified' : 'Exact identity verified';
        var isSelected = state.selectedHandles.indexOf(product.handle) !== -1;
        var material = materialValue(product);
        var signals = [];
        if (material) signals.push(material);
        if (/kickstand|stand/i.test(productText(product))) signals.push('Stand');
        if (/strap/i.test(productText(product))) signals.push('Strap');
        var compareAt = variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)
          ? '<del>' + money(variant.compare_at_price) + '</del>' : '';
        return '<article class="avcs-product-card' + (isSelected ? ' is-selected' : '') + '" data-avcs-card="' + escapeHtml(product.handle) + '">' +
          '<a class="avcs-product-card__visual" href="' + productUrl(product, variant) + '" aria-label="Read full details for ' + escapeHtml(product.title) + '">' +
            '<img src="' + escapeHtml(productImage(product, variant)) + '" alt="' + escapeHtml(product.title) + '" loading="lazy" width="480" height="480"><span>Full details ↗</span>' +
          '</a>' +
          '<div class="avcs-product-card__body"><div class="avcs-fit"><span>✓</span> ' + evidenceLabel + ' <button type="button" data-avcs-inspect="' + escapeHtml(product.handle) + '">Why?</button></div>' +
          '<a class="avcs-product-card__title" href="' + productUrl(product, variant) + '">' + escapeHtml(product.title) + '</a>' +
          '<p class="avcs-product-card__variant">' + escapeHtml(variant.title) + '</p>' +
          '<p class="avcs-match-proof"><span>Fit evidence</span>' + escapeHtml(evidence.source) + '</p>' +
          '<div class="avcs-product-card__price"><strong>' + money(variant.price) + '</strong>' + compareAt + '</div>' +
          '<div class="avcs-card-signals">' + signals.slice(0, 3).map(function (signal) { return '<span>' + escapeHtml(signal) + '</span>'; }).join('') + '</div>' +
          '<div class="avcs-product-card__actions"><button type="button" data-avcs-toggle="' + escapeHtml(product.handle) + '" class="' + (isSelected ? 'is-selected' : '') + '" aria-pressed="' + isSelected + '">' + (isSelected ? '✓ Added to comparison' : '+ Add to comparison') + '</button>' +
          '<button type="button" data-avcs-inspect="' + escapeHtml(product.handle) + '" aria-label="Quick view ' + escapeHtml(product.title) + '">↗</button></div></div></article>';
      }).join('');
    }

    function renderPriorities() {
      els.priorities.innerHTML = PRIORITIES.map(function (pair) {
        return '<button type="button" data-avcs-priority="' + pair[0] + '" class="' + (state.priority === pair[0] ? 'is-active' : '') + '" aria-pressed="' + (state.priority === pair[0]) + '">' + escapeHtml(pair[0] === 'all' && state.device && state.device.watchLaunchModel ? 'All accessory matches' : pair[1]) + '</button>';
      }).join('');
    }

    function renderComparison() {
      var details = selectedDetails();
      var visible = details.length >= 2;
      els.compare.hidden = !visible;
      els.mobileBar.hidden = !details.length;
      els.mobileCount.textContent = details.length + (details.length === 1 ? ' product selected' : ' products selected');
      els.mobileAdd.textContent = 'Add all · ' + money(details.reduce(function (sum, item) { return sum + Number(item.variant.price); }, 0));
      if (!visible) return;

      renderPriorities();
      els.selectedCount.textContent = details.length + ' products selected';
      var lowestPrice = Math.min.apply(Math, details.map(function (item) { return Number(item.variant.price); }));
      var ranked = details.map(function (item) {
        return { product: item.product, variant: item.variant, score: scoreProduct(item.product, item.variant, state.priority, lowestPrice) };
      }).sort(function (a, b) { return b.score - a.score; });
      var winner = ranked[0];
      var priorityLabel = (PRIORITIES.find(function (pair) { return pair[0] === state.priority; }) || [null, 'Your priority'])[1];
      els.recommendation.innerHTML = '<div class="avcs-recommendation"><div class="avcs-recommendation__mark">A*</div><div><span>Current recommendation · ' + escapeHtml(priorityLabel) + '</span><h3>' + escapeHtml(displaySafeText(winner.product.title)) + '</h3></div><p><strong>Why this leads:</strong> ' +
        (winner.score > 0 ? 'Its published product information contains the strongest verified signal for ' + escapeHtml(priorityLabel.toLowerCase()) + '.' : 'The live product information does not specify enough detail to declare a strong winner; review the aligned evidence below.') + '</p></div>';

      var category = detectComparisonCategory(state.device, details);
      var rows = comparisonRows(category).map(function (row) {
        var values = details.map(function (item) { return rawRowValue(row, item.product, item.variant); });
        return { row: row, values: values };
      }).filter(function (entry) {
        var hasAnyValue = entry.values.some(function (value) { return !!categoryDisplayText(value, category); });
        if (!hasAnyValue) return false;
        var valueSet = unique(entry.values.map(function (value) { return rowComparisonKey(value, category); }));
        return !state.differencesOnly || valueSet.length > 1;
      });

      var head = '<thead><tr><th>Compared products</th>' + details.map(function (item) {
        var variants = matchingVariants(item.product, state.device);
        var displayTitle = displaySafeText(item.product.title);
        return '<th><button class="avcs-table__remove" type="button" data-avcs-toggle="' + escapeHtml(item.product.handle) + '" aria-label="Remove ' + escapeHtml(displayTitle) + '">×</button>' +
          '<div class="avcs-table__product"><a href="' + productUrl(item.product, item.variant) + '"><img src="' + escapeHtml(productImage(item.product, item.variant)) + '" alt="' + escapeHtml(displayTitle) + '" width="160" height="160"></a>' +
          '<div><h3><a href="' + productUrl(item.product, item.variant) + '">' + escapeHtml(displayTitle) + '</a></h3><label>Exact-fit variant<select data-avcs-variant="' + escapeHtml(item.product.handle) + '">' +
          variants.map(function (variant) { return '<option value="' + escapeHtml(variant.id) + '"' + (String(variant.id) === String(item.variant.id) ? ' selected' : '') + '>' + escapeHtml(categoryDisplayText(variant.title, category)) + ' · ' + money(variant.price) + '</option>'; }).join('') +
          '</select></label><button class="avcs-table__cart" type="button" data-avcs-add-one="' + escapeHtml(item.product.handle) + '">Add to cart · ' + money(item.variant.price) + '</button></div></div></th>';
      }).join('') + '</tr></thead>';

      var body = '<tbody>';
      var previousGroup = '';
      rows.forEach(function (entry) {
        var row = entry.row;
        if (row.group !== previousGroup) {
          body += '<tr class="avcs-table__group"><td colspan="' + (details.length + 1) + '">' + escapeHtml(row.group) + '</td></tr>';
          previousGroup = row.group;
        }
        var different = unique(entry.values.map(function (value) { return rowComparisonKey(value, category); })).length > 1;
        body += '<tr><td>' + escapeHtml(row.label) + '</td>' + entry.values.map(function (value) {
          var cell = formatRowCell(row, value, category);
          var classes = [cell.className];
          if (different) classes.push('is-different');
          return '<td class="' + classes.join(' ') + '">' + escapeHtml(cell.text) + '</td>';
        }).join('') + '</tr>';
      });
      body += '</tbody>';
      els.table.innerHTML = '<table class="avcs-table" data-avcs-category="' + escapeHtml(category) + '">' + head + body + '</table>';
    }

    function renderAll() {
      if (!state.device) return;
      renderConfirmation();
      renderFilters();
      renderProducts();
      renderComparison();
      els.syncTime.textContent = 'Live availability verified';
    }

    function toggleProduct(handle) {
      var index = state.selectedHandles.indexOf(handle);
      if (index !== -1) {
        state.selectedHandles.splice(index, 1);
        track('compare_product_removed', { handle: handle });
      } else {
        if (state.selectedHandles.length >= 4) { notify('You can compare up to four products. Remove one to add another.'); return; }
        var product = state.compatible.find(function (item) { return item.handle === handle; });
        var variant = product && matchingVariants(product, state.device)[0];
        if (!variant) return;
        state.selectedHandles.push(handle);
        state.selectedVariants[handle] = variant.id;
        track('compare_product_added', { handle: handle });
      }
      renderProducts();
      renderComparison();
      syncUrl();
    }

    function openDialog(handle) {
      var product = state.catalog.find(function (item) { return item.handle === handle; });
      if (!product || !state.device) return;
      var variants = matchingVariants(product, state.device);
      var variant = variants.find(function (item) { return String(item.id) === String(state.selectedVariants[handle]); }) || variants[0];
      if (!variant) return;
      state.dialogHandle = handle;
      var images = (product.images || []).slice(0, 4);
      var category = detectComparisonCategory(state.device, [{ product: product, variant: variant }]);
      var specs = comparisonRows(category).map(function (row) {
        return { row: row, value: rawRowValue(row, product, variant) };
      }).filter(function (entry) {
        return !!categoryDisplayText(entry.value, category);
      }).map(function (entry) {
        var cell = formatRowCell(entry.row, entry.value, category);
        return '<div><span>' + escapeHtml(entry.row.label) + '</span><strong class="' + escapeHtml(cell.className) + '">' + escapeHtml(cell.text) + '</strong></div>';
      }).join('');
      var dialogEvidence = fitEvidence(product, variant, state.device);
      var displayTitle = displaySafeText(product.title);
      els.dialogContent.innerHTML = '<div class="avcs-dialog__inner"><div class="avcs-dialog__gallery">' + images.map(function (image, index) {
        return '<a href="' + productUrl(product, variant) + '" aria-label="Open full product page for ' + escapeHtml(displayTitle) + ', image ' + (index + 1) + '"><img src="' + escapeHtml(image.src) + '" alt="' + escapeHtml(displayTitle) + ', view ' + (index + 1) + '" width="420" height="420"></a>';
      }).join('') + '</div><div class="avcs-dialog__copy"><p class="avcs-eyebrow"><span></span>Product intelligence</p><h2>' + escapeHtml(displayTitle) + '</h2>' +
      '<div class="avcs-dialog__fit"><strong>✓ ' + (state.device.watchLaunchModel ? 'Listed model matched for ' : 'Exact fit verified for ') + escapeHtml(state.device.label) + '</strong><br>' + escapeHtml(displaySafeText(dialogEvidence.reason)) + '<br><small>Evidence: ' + escapeHtml(categoryDisplayText(dialogEvidence.source, category)) + '</small></div>' +
      '<label>Choose a live exact-fit variant<select data-avcs-dialog-variant="' + escapeHtml(handle) + '">' + variants.map(function (item) { return '<option value="' + escapeHtml(item.id) + '"' + (String(item.id) === String(variant.id) ? ' selected' : '') + '>' + escapeHtml(categoryDisplayText(item.title, category)) + ' · ' + money(item.price) + '</option>'; }).join('') + '</select></label>' +
      '<div class="avcs-dialog__price">' + money(variant.price) + '</div><div class="avcs-dialog__specs">' + specs + '</div><div class="avcs-dialog__actions"><button type="button" data-avcs-dialog-add="' + escapeHtml(handle) + '">Add exact variant to cart →</button><a href="' + productUrl(product, variant) + '">Read full product details ↗</a></div></div></div>';
      if (!els.dialog.open && typeof els.dialog.showModal === 'function') els.dialog.showModal();
      else if (!els.dialog.open) els.dialog.setAttribute('open', '');
      track('compare_product_details_opened', { handle: handle });
    }

    async function addToCart(items) {
      if (!items.length) return;
      var buttons = [els.addAll, els.mobileAdd].filter(Boolean);
      buttons.forEach(function (button) { button.disabled = true; });
      try {
        var shopRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
        var sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
        var response = await fetch(shopRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({
            items: items.map(function (item) {
              return {
                id: Number(item.id),
                quantity: 1,
                properties: {
                  '_Source': 'Compare Studio',
                  '_Device': state.device ? state.device.label : ''
                }
              };
            }),
            sections: sections.join(','),
            sections_url: window.location.pathname
          })
        });
        var result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Cart request failed');
        var cartResponse = await fetch(shopRoot + 'cart.js', { headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
        if (!cartResponse.ok) throw new Error('Cart refresh failed');
        var cart = await cartResponse.json();
        cart.sections = result.sections || {};
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open', cart: cart } }));
        document.dispatchEvent(new CustomEvent('avontic:cart-updated', { detail: { source: 'compare-studio', result: result, cart: cart, item_count: cart.item_count, sections: cart.sections } }));
        track('compare_add_to_cart', { products: items.length, variant_ids: items.map(function (item) { return item.id; }), currency: DISPLAY_CURRENCY });
        notify(items.length === 1 ? 'Added to cart.' : items.length + ' exact variants added to cart.');
        if (els.dialog.open && typeof els.dialog.close === 'function') els.dialog.close();
      } catch (_error) {
        notify('We could not add those variants. Please retry or open the product page.');
      } finally {
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        buttons.forEach(function (button) { button.disabled = false; });
      }
    }

    function addAll() {
      addToCart(selectedDetails().map(function (item) { return { id: item.variant.id }; }));
    }

    function shareComparison() {
      var url = window.location.href;
      if (navigator.share) {
        navigator.share({ title: 'My Avontic comparison', url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () { notify('Comparison link copied.'); }).catch(function () { notify('Your comparison is saved in this page URL.'); });
      } else notify('Your comparison is saved in this page URL.');
      track('compare_shared', { products: state.selectedHandles.length });
    }

    function saveComparison() {
      try {
        localStorage.setItem('avontic-comparison', JSON.stringify({ device: state.device && state.device.label, handles: state.selectedHandles, variants: state.selectedVariants }));
        notify('Comparison saved on this device.');
        track('compare_saved', { products: state.selectedHandles.length });
      } catch (_error) { notify('Use Share to keep this comparison URL.'); }
    }

    els.searchForms.forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var query = form.querySelector('[data-avcs-query]').value.trim();
        if (!query) { notify('Enter the complete device model first.'); return; }
        if (!state.catalog.length) { notify('We are still checking live availability. Please try again in a moment.'); return; }
        applyDevice(query);
      });
    });
    els.queryInputs.forEach(function (input) { input.addEventListener('input', function () { setQueries(input.value); }); });
    els.category.addEventListener('change', function () { els.brand.value = ''; els.model.value = ''; renderGuidedDevice(); });
    els.brand.addEventListener('change', function () { els.model.value = ''; renderGuidedDevice(); });
    els.confirmModel.addEventListener('click', function () { if (els.model.value) applyDevice(els.model.value); });
    els.quick.addEventListener('click', function (event) { var button = event.target.closest('[data-avcs-quick]'); if (button) applyDevice(button.dataset.avcsQuick); });
    els.confirmation.addEventListener('click', function (event) { if (event.target.closest('[data-avcs-change-device]')) root.querySelector('[data-avcs-query]').focus(); });
    els.filters.addEventListener('click', function (event) { var button = event.target.closest('[data-avcs-filter]'); if (!button) return; state.filter = button.dataset.avcsFilter; renderFilters(); renderProducts(); });
    els.products.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-avcs-toggle]');
      var inspect = event.target.closest('[data-avcs-inspect]');
      if (toggle) toggleProduct(toggle.dataset.avcsToggle);
      else if (inspect) openDialog(inspect.dataset.avcsInspect);
    });
    els.priorities.addEventListener('click', function (event) { var button = event.target.closest('[data-avcs-priority]'); if (!button) return; state.priority = button.dataset.avcsPriority; renderComparison(); track('compare_priority_changed', { priority: state.priority }); });
    els.differences.addEventListener('click', function () { state.differencesOnly = !state.differencesOnly; els.differences.setAttribute('aria-pressed', String(state.differencesOnly)); els.differences.textContent = (state.differencesOnly ? '✓ ' : '') + 'Show differences only'; renderComparison(); });
    els.table.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-avcs-toggle]');
      var addOneButton = event.target.closest('[data-avcs-add-one]');
      if (toggle) toggleProduct(toggle.dataset.avcsToggle);
      if (addOneButton) {
        var detail = selectedDetails().find(function (item) { return item.product.handle === addOneButton.dataset.avcsAddOne; });
        if (detail) addToCart([{ id: detail.variant.id }]);
      }
    });
    els.table.addEventListener('change', function (event) {
      var select = event.target.closest('[data-avcs-variant]');
      if (!select) return;
      state.selectedVariants[select.dataset.avcsVariant] = select.value;
      renderProducts(); renderComparison(); syncUrl();
      track('compare_variant_selected', { handle: select.dataset.avcsVariant, variant_id: select.value });
    });
    els.dialogContent.addEventListener('change', function (event) {
      var select = event.target.closest('[data-avcs-dialog-variant]');
      if (!select) return;
      state.selectedVariants[select.dataset.avcsDialogVariant] = select.value;
      openDialog(select.dataset.avcsDialogVariant);
    });
    els.dialogContent.addEventListener('click', function (event) {
      var button = event.target.closest('[data-avcs-dialog-add]');
      if (!button) return;
      var product = state.catalog.find(function (item) { return item.handle === button.dataset.avcsDialogAdd; });
      var variants = product && matchingVariants(product, state.device);
      var variant = variants && (variants.find(function (item) { return String(item.id) === String(state.selectedVariants[product.handle]); }) || variants[0]);
      if (variant) addToCart([{ id: variant.id }]);
    });
    els.closeDialog.addEventListener('click', function () { els.dialog.close(); });
    els.dialog.addEventListener('click', function (event) {
      var rect = els.dialog.getBoundingClientRect();
      var outside = event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
      if (outside) els.dialog.close();
    });
    els.share.addEventListener('click', shareComparison);
    els.save.addEventListener('click', saveComparison);
    els.addAll.addEventListener('click', addAll);
    els.mobileAdd.addEventListener('click', addAll);

    renderQuickDevices();
    renderGuidedDevice();

    (async function loadCatalog() {
      var pageTotal = 6;
      var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
      function updateProgress() {
        els.loading.hidden = false;
        els.loading.textContent = 'Checking live availability…';
      }

      function fetchCatalogPage(page, forceRefresh) {
        var controller = typeof AbortController === 'function' ? new AbortController() : null;
        var timeout = controller ? window.setTimeout(function () { controller.abort(); }, 15000) : null;
        var options = {
          credentials: 'same-origin',
          cache: forceRefresh ? 'reload' : 'no-cache',
          headers: { 'Accept': 'application/json' }
        };
        if (controller) options.signal = controller.signal;

        return fetch(rootPath + 'products.json?limit=250&page=' + page, options)
          .then(function (response) {
            if (!response.ok) throw new Error('Catalog page ' + page + ' returned ' + response.status);
            return response.json();
          })
          .then(function (payload) {
            return {
              page: page,
              products: Array.isArray(payload.products) ? payload.products : []
            };
          })
          .finally(function () {
            if (timeout) window.clearTimeout(timeout);
          });
      }

      function fetchWithProgress(page, forceRefresh) {
        return fetchCatalogPage(page, forceRefresh).then(function (result) {
          updateProgress();
          return result;
        }, function (error) {
          updateProgress();
          throw error;
        });
      }

      try {
        updateProgress();
        var pages = Array.from({ length: pageTotal }, function (_value, index) { return index + 1; });
        var pageResults = await Promise.allSettled(pages.map(function (page) {
          return fetchWithProgress(page, false);
        }));

        for (var failedIndex = 0; failedIndex < pageResults.length; failedIndex += 1) {
          if (pageResults[failedIndex].status === 'rejected') {
            pageResults[failedIndex] = {
              status: 'fulfilled',
              value: await fetchCatalogPage(failedIndex + 1, true)
            };
          }
        }

        var collected = [];
        pageResults
          .map(function (result) { return result.value; })
          .sort(function (a, b) { return a.page - b.page; })
          .forEach(function (result) { collected = collected.concat(result.products); });
        if (!collected.length) throw new Error('The live catalog returned no products');

        var map = new Map();
        collected.forEach(function (product) { map.set(product.id, product); });
        state.catalog = Array.from(map.values());
        state.catalogVariantCount = state.catalog.reduce(function (total, product) { return total + (product.variants || []).length; }, 0);
        els.count.textContent = 'Live availability verified';
        els.searchSubmit.disabled = false;
        els.loading.textContent = 'Verifying exact model, generation, size and compatible variants…';
        if (els.modelCount) els.modelCount.textContent = 'We verify model, generation, size and compatible variant details before showing results.';
        renderOrbit();

        state.deviceOptions = await buildCatalogDeviceOptions(state.catalog, function (processed, total, index) {
          els.loading.textContent = 'Verifying exact model, generation, size and compatible variants…';
          if (processed === total || processed % 120 < 40) {
            state.deviceOptions = sortedDeviceOptions(index);
            renderGuidedDevice();
            if (els.modelCount) els.modelCount.textContent = 'We verify model, generation, size and compatible variant details before showing results.';
          }
        });

        els.loading.hidden = true;
        if (els.modelCount) els.modelCount.textContent = 'We verify model, generation, size and compatible variant details before showing results.';
        renderGuidedDevice();
        track('compare_site_viewed', { product_count: state.catalog.length, variant_count: state.catalogVariantCount, device_model_count: state.deviceOptions.length });

        var params = new URLSearchParams(window.location.search);
        var savedDevice = params.get('device');
        var savedProducts = (params.get('compare') || params.get('products') || '').split(',').filter(Boolean);
        if (savedDevice) applyDevice(savedDevice, savedProducts);
      } catch (error) {
        els.loading.classList.add('is-error');
        els.loading.hidden = false;
        els.loading.innerHTML = 'We could not verify live availability. <button type="button" data-avcs-retry>Try again</button>';
        els.loading.querySelector('button').addEventListener('click', function () { window.location.reload(); });
        if (window.console && typeof window.console.error === 'function') window.console.error('[Avontic Compare] Availability verification failed', error);
      }
    })();

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { root.dataset.motion = entry.isIntersecting ? 'running' : 'paused'; });
      }, { rootMargin: '100px' });
      observer.observe(root.querySelector('[data-avcs-orbit]'));
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-avcs-root]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();

